import { createSvgIcon, styled } from '@mui/material'
import React from 'react'

export interface SvgIconProps {
  background?: string
  color: string
}

export const EmptySvg: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='22'
    viewBox='0 0 17 22'
    fill='none'
  ></svg>
)

export const WholeBuildingIcon: React.FC<SvgIconProps> = ({
  background,
  color,
}) => (
  <svg
    width='22'
    height='23'
    viewBox='0 0 22 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M1 16.5V9L15 1L21 8.5V16.5L11 22L1 16.5Z' fill={background} />
    <path
      d='M11.0778 18.1368V21.8981L1 16.3563V12.5942'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.1559 12.5942V16.3563L11.0781 21.8981V18.1368'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M1 12.5778V8.81569L6.03891 6.04443L11.0778 14.3582V18.1203'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0781 18.12V14.358L21.1559 8.81543V12.5775'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M1 8.81564L15.1793 1L21.1556 8.79716V12.5592'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

export const StackableViewIcon: React.FC<SvgIconProps> = ({
  background,
  color,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='26'
    viewBox='0 0 22 26'
    fill='none'
  >
    <path
      d='M11.0771 24.9367L1 19.3949V15.6328L11.0771 21.1753V24.9367Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.155 19.3949L11.0771 24.9367V21.1753L21.155 15.6328V19.3949Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 24.9367L1 19.3949V15.6328L11.0771 21.1753V24.9367Z'
      fill={background}
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.155 19.3949L11.0771 24.9367V21.1753L21.155 15.6328V19.3949Z'
      fill={background}
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 10.0903L21.1549 15.6329L11.0771 21.1754L1 15.6329L11.0771 10.0903Z'
      fill={background}
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.155 15.6329L11.0771 10.0903'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 10.0903L1 15.6329'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.155 12.5586L11.0771 7.01611'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 7.01611L1 12.5586'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 18.1196L1 12.5778V8.81569L6.0389 6.04443L11.0771 14.3575V18.1196Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M21.155 12.5775L11.0771 18.1193V14.3573L21.155 8.81543V12.5775Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M11.0771 7.01598V3.25391'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M1 8.81564L15.1793 1L21.1549 8.79648V12.5586'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

//#region Building Editing Tools
export const DirectSelectIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M16.4956 7.52567C17.037 7.31514 17.3077 7.20988 17.3836 7.06105C17.4495 6.9321 17.4475 6.77898 17.3783 6.65181C17.2984 6.50502 17.0251 6.4069 16.4784 6.21065L2.53484 1.20528C2.08757 1.04472 1.86394 0.964445 1.71774 1.01507C1.59063 1.05909 1.49073 1.15899 1.44672 1.2861C1.39609 1.4323 1.47636 1.65593 1.63692 2.1032L6.64226 16.0467C6.83851 16.5934 6.93664 16.8668 7.08342 16.9466C7.21059 17.0158 7.36372 17.0178 7.49266 16.952C7.64149 16.876 7.74676 16.6053 7.95728 16.064L10.2361 10.2043C10.2773 10.0982 10.2979 10.0452 10.3298 10.0006C10.358 9.96099 10.3926 9.92638 10.4322 9.89815C10.4768 9.8663 10.5299 9.84568 10.6359 9.80444L16.4956 7.52567Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'DirectSelectIcon',
)

export const MarqueeIcon = createSvgIcon(
  <svg
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_68_2)'>
      <path
        d='M20.9994 4.36035H4.35938V21.0004H20.9994V4.36035Z'
        stroke='currentColor'
        strokeDasharray='1.68 1.68'
      />
      <path d='M0.661621 4.36183H8.22162' stroke='currentColor' />
      <path d='M4.36084 8.22121V0.661209' stroke='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_68_2'>
        <rect width='22' height='22' fill='white' />
      </clipPath>
    </defs>
  </svg>,
  'MarqueeIcon',
)

export const MeasureIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25 8' fill='none'>
    <line
      x1='3.19629'
      y1='4'
      x2='22.1963'
      y2='4'
      stroke='currentColor'
      strokeDasharray='2 2'
    />
    <line x1='3.69629' y1='0.5' x2='3.69629' y2='7.5' stroke='currentColor' />
    <line
      x1='6.0225'
      y1='1.87894'
      x2='1.07275'
      y2='6.82869'
      stroke='currentColor'
    />
    <line
      x1='24.4991'
      y1='1.87894'
      x2='19.5493'
      y2='6.82869'
      stroke='currentColor'
    />
    <line x1='22.6963' y1='0.5' x2='22.6963' y2='7.5' stroke='currentColor' />
  </svg>,
  'MeasureIcon',
)

export const AnnotationIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'>
    <path
      d='M7.92649 14H6.52876L9.66939 5.27273H11.1907L14.3313 14H12.9336L10.4663 6.85795H10.3981L7.92649 14ZM8.16087 10.5824H12.695V11.6903H8.16087V10.5824Z'
      fill='currentColor'
    />
    <rect
      x='1.43164'
      y='0.5'
      width='18'
      height='19'
      rx='3.5'
      stroke='currentColor'
    />
  </svg>,
  'AnnotationIcon',
)

export const FlipIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17 16' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.727084 14.7009C0.652663 14.8791 0.672276 15.0828 0.779579 15.2432C0.886306 15.4035 1.06688 15.4999 1.25956 15.4999H7.02857C7.34702 15.4999 7.60547 15.2414 7.60547 14.923V1.07736C7.60547 0.802175 7.41163 0.565644 7.14164 0.511415C6.87223 0.457764 6.60166 0.601417 6.49609 0.855253L0.727084 14.7009ZM2.12491 14.3461L6.45167 3.96186V14.3461H2.12491Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.6037 15.4999C15.7964 15.4999 15.977 15.4035 16.0837 15.2432C16.191 15.0828 16.2106 14.8791 16.1362 14.7009L10.3672 0.855253C10.2616 0.601417 9.99105 0.457764 9.72164 0.511415C9.45165 0.565644 9.25781 0.802175 9.25781 1.07736V14.923C9.25781 15.2414 9.51626 15.4999 9.83471 15.4999H15.6037ZM14.7384 14.3461H10.4116V3.96186L14.7384 14.3461Z'
      fill='currentColor'
    />
  </svg>,
  'FlipIcon',
)

export const GridIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 16' fill='none'>
    <line
      x1='3.24805'
      y1='0.230713'
      x2='3.24805'
      y2='15.7692'
      stroke='currentColor'
    />
    <line
      x1='8.42773'
      y1='0.230713'
      x2='8.42773'
      y2='15.7692'
      stroke='currentColor'
    />
    <line
      x1='13.6074'
      y1='0.230713'
      x2='13.6074'
      y2='15.7692'
      stroke='currentColor'
    />
    <line
      x1='18.7871'
      y1='0.230713'
      x2='18.7871'
      y2='15.7692'
      stroke='currentColor'
    />
    <line
      x1='23.9668'
      y1='0.230713'
      x2='23.9668'
      y2='15.7692'
      stroke='currentColor'
    />
    <line
      x1='0.806641'
      y1='12.678'
      x2='26.0566'
      y2='12.678'
      stroke='currentColor'
    />
    <line
      x1='0.806641'
      y1='7.82251'
      x2='26.0566'
      y2='7.82251'
      stroke='currentColor'
    />
    <line
      x1='0.806641'
      y1='2.96704'
      x2='26.0566'
      y2='2.96704'
      stroke='currentColor'
    />
  </svg>,
  'GridIcon',
)

export const CommentIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'>
    <mask id='path-1-inside-1_4043_628' fill='white'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.24255 15.9966C12.5487 15.8685 16.0002 12.3374 16.0002 8.00012C16.0002 3.58177 12.4185 0 8.00012 0C3.66305 0 0.132056 3.45121 0.00361884 7.75716H0V8.00012V15.9997H7.90696C7.93797 16.0001 7.96902 16.0002 8.00012 16.0002C8.03121 16.0002 8.06226 16.0001 8.09327 15.9997H8.24255V15.9966Z'
      />
    </mask>
    <path
      d='M8.24255 15.9966L8.2128 14.9971L7.24255 15.026V15.9966H8.24255ZM0.00361884 7.75716V8.75716H0.974236L1.00317 7.78697L0.00361884 7.75716ZM0 7.75716V6.75716H-1V7.75716H0ZM0 15.9997H-1V16.9997H0V15.9997ZM7.90696 15.9997L7.91837 14.9997H7.90696V15.9997ZM8.09327 15.9997V14.9996L8.08186 14.9998L8.09327 15.9997ZM8.24255 15.9997V16.9997H9.24255V15.9997H8.24255ZM15.0002 8.00012C15.0002 11.795 11.9801 14.885 8.2128 14.9971L8.27229 16.9962C13.1173 16.852 17.0002 12.8797 17.0002 8.00012H15.0002ZM8.00012 1C11.8662 1 15.0002 4.13406 15.0002 8.00012H17.0002C17.0002 3.02949 12.9707 -1 8.00012 -1V1ZM1.00317 7.78697C1.11554 4.01984 4.20535 1 8.00012 1V-1C3.12075 -1 -0.851428 2.88259 -0.995937 7.72734L1.00317 7.78697ZM0 8.75716H0.00361884V6.75716H0V8.75716ZM1 8.00012V7.75716H-1V8.00012H1ZM1 15.9997V8.00012H-1V15.9997H1ZM7.90696 14.9997H0V16.9997H7.90696V14.9997ZM8.00012 15.0002C7.97283 15.0002 7.94558 15.0001 7.91837 14.9998L7.89555 16.9996C7.93037 17 7.96522 17.0002 8.00012 17.0002V15.0002ZM8.08186 14.9998C8.05466 15.0001 8.02741 15.0002 8.00012 15.0002V17.0002C8.03502 17.0002 8.06987 17 8.10468 16.9996L8.08186 14.9998ZM8.24255 14.9997H8.09327V16.9997H8.24255V14.9997ZM7.24255 15.9966V15.9997H9.24255V15.9966H7.24255Z'
      fill='currentColor'
      mask='url(#path-1-inside-1_4043_628)'
    />
  </svg>,
  'CommentIcon',
)

export const RoofIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 19' fill='none'>
    <path
      d='M1 12.3333L11.0023 1L24.4428 6.66667L15.0657 18L1 12.3333Z'
      fill='#D9D9D9'
      stroke='#04002E'
      strokeLinejoin='round'
    />
    <path
      d='M24.4403 6.66895L28.8163 12.6504L21.8633 9.50027'
      stroke='#04002E'
      strokeLinejoin='round'
    />
  </svg>,
  'RoofIcon',
)

export const WallTransparencyIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 15' fill='none'>
    <path
      d='M1 10.9V1H19.7V10.9H17.6222V5.82308H14.654V10.9H1Z'
      stroke='#04002E'
    />
    <path
      opacity='0.8'
      d='M3.19922 14.2002V3.2002H22.9992V14.2002H3.19922Z'
      fill='url(#paint0_linear_4043_262)'
      fillOpacity='0.6'
      stroke='#04002E'
      strokeOpacity='0.3'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4043_262'
        x1='7.04922'
        y1='5.20019'
        x2='9.81614'
        y2='15.3456'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F5F5F5' />
        <stop offset='1' stopColor='#C7C7C7' />
      </linearGradient>
    </defs>
  </svg>,
  'WallTransparencyIcon',
)

export const BadgeIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 5' fill='none'>
    <circle cx='2.5' cy='2.5' r='2.5' fill='currentColor' />
  </svg>,
  'BadgeIcon',
)

//#endregion

//#region Building Objects
export const OrbitIcon = createSvgIcon(
  <svg
    width='14'
    viewBox='0 0 14 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3083 7.28719L13.3061 11.7975C13.2666 12.3275 12.9908 12.8311 12.4634 13.0008C12.3069 13.0513 12.0841 13.0334 11.9898 13.0754C11.9181 13.1076 11.6796 13.3969 11.5878 13.4774C9.09016 15.6579 5.03884 15.6678 2.50864 13.5308C2.39197 13.432 2.14765 13.1248 2.0489 13.0769C1.91284 13.0107 1.66304 13.0271 1.4948 12.9734C1.0091 12.8183 0.716504 12.2448 0.697485 11.7609L0.701143 7.30474C0.246526 7.21806 -0.0705722 6.92766 0.0135484 6.43354C0.0625578 6.1479 0.529975 5.82934 0.754541 5.64025C2.39855 4.25482 4.14241 2.8394 5.83323 1.51139C6.43634 1.03776 6.86901 0.585334 7.65316 1.11493L13.6703 5.98624C14.261 6.40502 14.0079 7.22611 13.3079 7.28755L13.3083 7.28719ZM7.00177 2.02453L1.813 6.29676L1.79434 11.6874C1.79727 11.8125 1.88468 11.9091 1.98746 11.9694L11.8636 11.9987C12.0051 12.0074 12.1134 11.9211 12.1814 11.8048L12.1913 6.29676L7.00251 2.02453H7.00177Z'
      fill='currentColor'
    />
    <path
      d='M4.38102 5.8688C6.0477 5.94889 7.87531 5.72725 9.52408 5.85709C10.2596 5.91524 10.9848 6.56188 11.0715 7.3058C11.1213 7.73079 11.1202 9.11402 10.9936 9.48525C10.7804 10.1096 10.2069 10.5298 9.55882 10.6081C7.91006 10.5112 6.11024 10.739 4.4794 10.6099C3.60308 10.5404 2.95499 9.85063 2.88989 8.98418C2.7926 7.68799 2.79114 6.1303 4.38138 5.8688H4.38102ZM4.96401 7.29263C4.29287 7.40637 4.28044 8.73548 4.96401 8.84593C5.97711 9.00979 5.96285 7.12329 4.96401 7.29263ZM8.49415 8.69598C8.79771 8.98016 9.28927 8.88031 9.4641 8.5036C9.71865 7.95535 9.39826 7.05746 8.69019 7.32774C8.22094 7.50695 8.16169 8.38437 8.49415 8.69598ZM6.0605 9.04307C5.81729 9.08696 5.81363 9.36309 5.95992 9.53097C6.2185 9.82832 6.84209 9.94791 7.21661 9.90988C7.51872 9.87879 8.37601 9.54669 8.11231 9.13231C7.93859 8.85983 7.74218 9.16852 7.62295 9.2563C7.30512 9.49037 6.762 9.49659 6.43795 9.27239C6.31506 9.18754 6.2474 9.00942 6.06087 9.0427L6.0605 9.04307Z'
      fill='currentColor'
    />
  </svg>,
  'ObjectsIcon',
)

export const ObjectsIcon = createSvgIcon(
  <svg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.50008 3.49996L6.12508 6.12496M3.50008 3.49996H1.75008L1.16675 1.74996L1.75008 1.16663L3.50008 1.74996V3.49996ZM11.2345 1.59888L9.70171 3.13166C9.4707 3.36267 9.3552 3.47817 9.31192 3.61137C9.27386 3.72852 9.27386 3.85473 9.31192 3.97189C9.3552 4.10508 9.4707 4.22058 9.70171 4.45159L9.84012 4.58999C10.0711 4.821 10.1866 4.93651 10.3198 4.97978C10.437 5.01785 10.5632 5.01785 10.6803 4.97978C10.8135 4.93651 10.929 4.821 11.16 4.58999L12.5938 3.15621C12.7483 3.53198 12.8334 3.94352 12.8334 4.37496C12.8334 6.14687 11.397 7.58329 9.62508 7.58329C9.41146 7.58329 9.20271 7.56241 9.00077 7.52259C8.71719 7.46666 8.5754 7.4387 8.48944 7.44726C8.39806 7.45637 8.35302 7.47007 8.27205 7.5134C8.19588 7.55416 8.11948 7.63056 7.96668 7.78336L3.79175 11.9583C3.3085 12.4415 2.525 12.4415 2.04175 11.9583C1.5585 11.475 1.5585 10.6915 2.04175 10.2083L6.21668 6.03336C6.36948 5.88056 6.44588 5.80416 6.48664 5.72799C6.52997 5.64702 6.54367 5.60198 6.55278 5.5106C6.56135 5.42464 6.53338 5.28285 6.47745 4.99927C6.43763 4.79733 6.41675 4.58858 6.41675 4.37496C6.41675 2.60305 7.85317 1.16663 9.62508 1.16663C10.2116 1.16663 10.7614 1.32402 11.2345 1.59888ZM7.00011 8.74993L10.2084 11.9582C10.6917 12.4415 11.4752 12.4415 11.9584 11.9582C12.4417 11.475 12.4417 10.6915 11.9584 10.2082L9.31901 7.56888C9.13217 7.5512 8.94999 7.51749 8.77387 7.46915C8.54692 7.40686 8.29797 7.45207 8.13155 7.61849L7.00011 8.74993Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'ObjectsIcon',
)

export const CalculationsIcon = createSvgIcon(
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.55005 7.45H5.25005M6.35005 9.65H5.25005M9.65005 5.25H5.25005M11.85 7.175V5.14C11.85 4.21591 11.85 3.75387 11.6702 3.40092C11.512 3.09045 11.2596 2.83803 10.9491 2.67984C10.5962 2.5 10.1341 2.5 9.21005 2.5H5.69005C4.76596 2.5 4.30392 2.5 3.95096 2.67984C3.6405 2.83803 3.38808 3.09045 3.22989 3.40092C3.05005 3.75387 3.05005 4.21591 3.05005 5.14V10.86C3.05005 11.7841 3.05005 12.2461 3.22989 12.5991C3.38808 12.9096 3.6405 13.162 3.95096 13.3202C4.30392 13.5 4.76596 13.5 5.69005 13.5H7.17505M12.95 13.5L12.125 12.675M12.675 11.3C12.675 12.3631 11.8132 13.225 10.75 13.225C9.6869 13.225 8.82505 12.3631 8.82505 11.3C8.82505 10.2369 9.6869 9.375 10.75 9.375C11.8132 9.375 12.675 10.2369 12.675 11.3Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'CalculationsIcon',
)

export const RuleBookIcon = createSvgIcon(
  <svg viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7 13L6.93496 12.8999C6.48345 12.2053 6.25769 11.858 5.95942 11.6065C5.69536 11.3839 5.3911 11.2169 5.06404 11.1151C4.69461 11 4.28762 11 3.47364 11H2.58C1.85193 11 1.4879 11 1.20981 10.8547C0.965202 10.7268 0.766327 10.5229 0.641692 10.272C0.5 9.98677 0.5 9.6134 0.5 8.86667V3.13333C0.5 2.3866 0.5 2.01323 0.641692 1.72801C0.766327 1.47713 0.965202 1.27316 1.20981 1.14532C1.4879 1 1.85193 1 2.58 1H2.84C4.29614 1 5.0242 1 5.58038 1.29065C6.0696 1.54631 6.46735 1.95426 6.71662 2.45603C7 3.02646 7 3.77319 7 5.26667M7 13V5.26667M7 13L7.06504 12.8999C7.51655 12.2053 7.74231 11.858 8.04058 11.6065C8.30464 11.3839 8.6089 11.2169 8.93596 11.1151C9.30539 11 9.71238 11 10.5264 11H11.42C12.1481 11 12.5121 11 12.7902 10.8547C13.0348 10.7268 13.2337 10.5229 13.3583 10.272C13.5 9.98677 13.5 9.6134 13.5 8.86667V6V3.13333C13.5 2.3866 13.5 2.01323 13.3583 1.72801C13.2337 1.47713 13.0348 1.27316 12.7902 1.14532C12.5121 1 12.1481 1 11.42 1H11.16C9.70386 1 8.9758 1 8.41962 1.29065C7.9304 1.54631 7.53265 1.95426 7.28338 2.45603C7 3.02646 7 3.77319 7 5.26667'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'RuleBookIcon',
)

export const WallsIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 18' fill='none'>
    <path
      d='M0.62207 17.5V0.5H32.6221V17.5H29.0665V8.78205H23.9872V17.5H0.62207Z'
      stroke='currentColor'
    />
  </svg>,
  'WallsIcon',
)

export const DoorsIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 22' fill='none'>
    <path
      d='M15.022 0.96875H2.59961V21.0299H15.022V0.96875Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.9905 18.713L2.59961 21.0299V0.96875L10.9905 3.28569V18.713Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.08008 21.0312H16.543'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.58008 10.0566V11.9779'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'DoorsIcon',
)

export const WindowsIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 22' fill='none'>
    <path
      d='M1.31201 0.490723C1.08436 0.53364 0.920159 0.735166 0.92389 0.968413V21.0314C0.92389 21.2945 1.13848 21.5091 1.40158 21.5091H18.5984C18.8615 21.5091 19.0761 21.2945 19.0761 21.0314V0.968413C19.0761 0.70531 18.8615 0.490723 18.5984 0.490723H1.40158C1.38665 0.490723 1.37173 0.490723 1.3568 0.490723C1.34187 0.490723 1.32694 0.490723 1.31201 0.490723ZM1.87927 1.4461H18.1208V20.5537H1.87927V1.4461ZM2.83465 2.40149V19.5984H17.1654V2.40149H2.83465ZM3.79003 3.35687H9.52232V8.61146H3.79003V3.35687ZM10.4777 3.35687H16.21V8.61146H10.4777V3.35687ZM3.79003 9.56685H9.52232V18.643H3.79003V9.56685ZM10.4777 9.56685H16.21V18.643H10.4777V9.56685Z'
      fill='currentColor'
    />
  </svg>,
  'WindowsIcon',
)

export const FramingIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 18' fill='none'>
    <rect
      x='1.42578'
      y='0.621582'
      width='2.39359'
      height='16.7551'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='6.21484'
      y='0.621582'
      width='2.39359'
      height='16.7551'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='11'
      y='0.621582'
      width='2.39359'
      height='16.7551'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='15.7891'
      y='0.621582'
      width='2.39359'
      height='16.7551'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='26.5586'
      y='14.9849'
      width='2.39359'
      height='8.37756'
      transform='rotate(90 26.5586 14.9849)'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='18.1797'
      y='14.9849'
      width='2.39359'
      height='16.7551'
      transform='rotate(90 18.1797 14.9849)'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='28.9531'
      y='7.62158'
      width='2.39359'
      height='27.5263'
      transform='rotate(90 28.9531 7.62158)'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='28.9531'
      y='0.621582'
      width='2.39359'
      height='27.5263'
      transform='rotate(90 28.9531 0.621582)'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
    <rect
      x='26.5586'
      y='0.621582'
      width='2.39359'
      height='16.7551'
      stroke='currentColor'
      strokeWidth='0.965402'
    />
  </svg>,
  'FramingIcon',
)

export const StairsIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29 16' fill='none'>
    <path
      d='M11.4853 15.1012L11.3474 15.1905H0.995117V11.6667H8.51639H9.01639V11.1667V6.23814H15.9206H16.4206V5.73814V0.80957H27.7611V4.56148L13.3191 13.9137L11.4853 15.1012Z'
      stroke='currentColor'
    />
  </svg>,
  'StairsIcon',
)

export const VentilationIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19 18' fill='none'>
    <path
      d='M15.8568 17.4341H2.53187C1.5325 17.4341 0.745117 16.6467 0.745117 15.6473V2.35267C0.745117 1.3533 1.5325 0.565918 2.53187 0.565918H15.8568C16.8562 0.565918 17.6436 1.3533 17.6436 2.35267V15.6776C17.6133 16.6467 16.8259 17.4341 15.8568 17.4341Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.19446 15.0115C12.5061 15.0115 15.1907 12.3269 15.1907 9.01526C15.1907 5.70364 12.5061 3.01904 9.19446 3.01904C5.88284 3.01904 3.19824 5.70364 3.19824 9.01526C3.19824 12.3269 5.88284 15.0115 9.19446 15.0115Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.19287 10.4087C9.96223 10.4087 10.5859 9.78499 10.5859 9.01562C10.5859 8.24625 9.96223 7.62256 9.19287 7.62256C8.4235 7.62256 7.7998 8.24625 7.7998 9.01562C7.7998 9.78499 8.4235 10.4087 9.19287 10.4087Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.19479 15.0109C9.19479 15.0109 8.31655 12.7699 8.8011 10.3472'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.19434 3.01904C9.19434 3.01904 10.0726 5.26005 9.58803 7.68277'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.19824 9.01559C3.19824 9.01559 5.43925 8.13735 7.86197 8.6219'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.5264 9.40883C12.9491 9.89337 15.1901 9.01514 15.1901 9.01514'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.95605 13.2556C4.95605 13.2556 5.92514 11.0449 7.98445 9.65186'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.4053 8.37869C12.4646 6.98563 13.4337 4.7749 13.4337 4.7749'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.95605 4.7749C4.95605 4.7749 7.16678 5.74399 8.55984 7.8033'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.83105 10.2261C11.2241 12.2854 13.4348 13.2545 13.4348 13.2545'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.19757 3.9884C3.68261 3.9884 4.0758 3.5952 4.0758 3.11017C4.0758 2.62513 3.68261 2.23193 3.19757 2.23193C2.71253 2.23193 2.31934 2.62513 2.31934 3.11017C2.31934 3.5952 2.71253 3.9884 3.19757 3.9884Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.1898 3.9884C15.6748 3.9884 16.068 3.5952 16.068 3.11017C16.068 2.62513 15.6748 2.23193 15.1898 2.23193C14.7047 2.23193 14.3115 2.62513 14.3115 3.11017C14.3115 3.5952 14.7047 3.9884 15.1898 3.9884Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.19757 15.7989C3.68261 15.7989 4.0758 15.4058 4.0758 14.9207C4.0758 14.4357 3.68261 14.0425 3.19757 14.0425C2.71253 14.0425 2.31934 14.4357 2.31934 14.9207C2.31934 15.4058 2.71253 15.7989 3.19757 15.7989Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.1898 15.7989C15.6748 15.7989 16.068 15.4058 16.068 14.9207C16.068 14.4357 15.6748 14.0425 15.1898 14.0425C14.7047 14.0425 14.3115 14.4357 14.3115 14.9207C14.3115 15.4058 14.7047 15.7989 15.1898 15.7989Z'
      stroke='currentColor'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'VentilationIcon',
)

export const ElectricalIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 18' fill='none'>
    <path
      d='M2.53308 0.849729L2.53308 5.87262L0.993809 5.86962L0.00363349 5.87562L0.00363341 6.95581L0.99981 6.95581L1.03582 11.3846C1.03882 12.2758 1.77395 13.0109 2.66211 13.0109L4.83449 13.0109L4.83749 17.4547L5.92369 17.4607L5.92369 13.0079L8.09907 13.0109C8.98723 13.0109 9.72236 12.2758 9.72536 11.3846L9.75837 6.95882L10.7575 6.96182L10.7605 5.87262L8.22809 5.87262L8.2281 0.843728L7.1419 0.849729V5.87262H3.61928L3.61928 0.843728L2.53308 0.849729ZM2.086 6.96182L8.67817 6.95881L8.63917 11.3786L8.64217 11.3816C8.64217 11.6877 8.40513 11.9247 8.09607 11.9277L2.66511 11.9217C2.35605 11.9247 2.12201 11.6907 2.12201 11.3786L2.086 6.96182Z'
      fill='currentColor'
    />
  </svg>,
  'ElectricalIcon',
)

export const PlumbingIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10' fill='none'>
    <path
      d='M6.95622 1.76978e-05C6.79013 0.00117799 6.63136 0.0607646 6.51484 0.165671C6.39831 0.270578 6.33357 0.412213 6.33486 0.559424L6.32996 1.11883H4.45608C4.37309 1.11779 4.2907 1.13138 4.21369 1.15881C4.13668 1.18623 4.06659 1.22695 4.00749 1.2786C3.94839 1.33025 3.90146 1.39179 3.86943 1.45965C3.8374 1.52751 3.8209 1.60034 3.8209 1.6739C3.8209 1.74746 3.8374 1.82029 3.86943 1.88815C3.90146 1.95601 3.94839 2.01755 4.00749 2.0692C4.06659 2.12084 4.13668 2.16156 4.21369 2.18899C4.2907 2.21642 4.37309 2.23001 4.45608 2.22897H6.32263L6.31529 3.33911H1.32478V0.00869066H0.0722656V9.99994H1.32478V6.66953H6.82168C6.88891 6.67931 6.95749 6.67931 7.02472 6.66953H9.42701C9.77956 6.66953 10.0533 6.91213 10.0533 7.2246V8.8898H9.42701C9.34403 8.88876 9.26163 8.90235 9.18462 8.92978C9.10761 8.95721 9.03752 8.99793 8.97842 9.04958C8.91932 9.10122 8.87239 9.16276 8.84036 9.23063C8.80833 9.29849 8.79183 9.37132 8.79183 9.44488C8.79183 9.51844 8.80833 9.59126 8.84036 9.65912C8.87239 9.72698 8.91932 9.78853 8.97842 9.84017C9.03752 9.89182 9.10761 9.93254 9.18462 9.95997C9.26163 9.9874 9.34403 10.001 9.42701 9.99994H10.0533H13.8108H14.4371C14.5201 10.001 14.6025 9.9874 14.6795 9.95997C14.7565 9.93254 14.8266 9.89182 14.8857 9.84017C14.9448 9.78853 14.9917 9.72698 15.0237 9.65912C15.0558 9.59126 15.0723 9.51844 15.0723 9.44488C15.0723 9.37132 15.0558 9.29849 15.0237 9.23063C14.9917 9.16276 14.9448 9.10122 14.8857 9.04958C14.8266 8.99793 14.7565 8.95721 14.6795 8.92978C14.6025 8.90235 14.5201 8.88876 14.4371 8.8898H13.8108V7.2246C13.8108 5.08517 11.8408 3.33911 9.42701 3.33911H7.56781L7.57515 2.22897H9.46615C9.54914 2.23001 9.63153 2.21642 9.70854 2.18899C9.78555 2.16156 9.85565 2.12084 9.91474 2.0692C9.97384 2.01755 10.0208 1.95601 10.0528 1.88815C10.0848 1.82029 10.1013 1.74746 10.1013 1.6739C10.1013 1.60034 10.0848 1.52751 10.0528 1.45965C10.0208 1.39179 9.97384 1.33025 9.91474 1.2786C9.85565 1.22695 9.78555 1.18623 9.70854 1.15881C9.63153 1.13138 9.54914 1.11779 9.46615 1.11883H7.58248L7.58738 0.568097C7.58934 0.493752 7.57442 0.419816 7.54352 0.350678C7.51262 0.281541 7.46637 0.21861 7.4075 0.165623C7.34863 0.112637 7.27834 0.0706735 7.20082 0.0422253C7.1233 0.0137772 7.04012 -0.000576081 6.95622 1.76978e-05ZM1.32478 4.44925H6.29572V5.55939H1.32478V4.44925ZM7.56047 4.44925H9.42701C11.164 4.44925 12.5583 5.68502 12.5583 7.2246V8.8898H11.3058V7.2246C11.3058 6.31147 10.4572 5.55939 9.42701 5.55939H7.55313L7.56047 4.44925Z'
      fill='currentColor'
    />
  </svg>,
  'PlumbingIcon',
)

export const FoundationIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 18' fill='none'>
    <path
      d='M5.93932 0.162598V3.50643H4.50625V4.46181H5.93932V7.80565H6.8947V4.46181H9.28315V7.80565H10.2385V4.46181H12.627V7.80565H13.5824V4.46181H15.0154V3.50643H13.5824V0.162598H12.627V3.50643H10.2385V0.162598H9.28315V3.50643H6.8947V0.162598H5.93932ZM1.80244 5.41719L0.207031 9.14076V17.8372H19.3147V9.12583L17.6987 5.89489H14.5378V6.85027H17.1091L18.0645 8.76103H1.40965L2.43314 6.37258H4.98394V5.41719H1.80244ZM1.16241 9.71641H18.3593V16.8818H1.16241V9.71641Z'
      fill='currentColor'
    />
  </svg>,
  'FoundationIcon',
)

export const BeamsIcon = createSvgIcon(
  <svg
    width='22'
    height='24'
    viewBox='0 0 22 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.257 0.75H20.6206L6.98424 15.75H0.620605L14.257 0.75Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path
      d='M3.95394 19.5L0.620605 23.25H6.98424L20.6206 8.25H16.8706'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path
      d='M3.95386 15.75L3.95386 22.4167L17.2872 8.3469V4.5'
      stroke='currentColor'
      strokeLinejoin='round'
    />
  </svg>,
  'BeamsIcon',
)
//#endregion

//#region BIM
export const SavedIcon = createSvgIcon(
  <svg viewBox='0 0 13 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.53016 1.85277C5.36941 0.495752 3.43379 0.130719 1.97945 1.37334C0.525112 2.61595 0.320362 4.69355 1.46246 6.1632C2.41204 7.38511 5.28579 9.96222 6.22765 10.7963C6.33303 10.8896 6.38572 10.9363 6.44717 10.9546C6.50081 10.9706 6.5595 10.9706 6.61314 10.9546C6.6746 10.9363 6.72729 10.8896 6.83266 10.7963C7.77452 9.96222 10.6483 7.38511 11.5979 6.1632C12.74 4.69355 12.5602 2.60288 11.0809 1.37334C9.60153 0.14379 7.69091 0.495752 6.53016 1.85277Z'
      fill='currentColor'
    />
  </svg>,
  'SavedIcon',
)

export const UploadFileIcon = createSvgIcon(
  <svg viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2.44457 8.30072C1.74442 7.83206 1.28345 7.03393 1.28345 6.12813C1.28345 4.76754 2.32353 3.64988 3.65199 3.52685C3.92373 1.87385 5.35913 0.612793 7.08906 0.612793C8.819 0.612793 10.2544 1.87385 10.5261 3.52685C11.8546 3.64988 12.8947 4.76754 12.8947 6.12813C12.8947 7.03393 12.4337 7.83206 11.7336 8.30072M4.76682 8.1601L7.08906 5.83785M7.08906 5.83785L9.41131 8.1601M7.08906 5.83785V11.0629'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'UploadFileIcon',
)

export const SearchIcon = createSvgIcon(
  <svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.4501 11.0629L8.92467 8.53746M10.289 5.25729C10.289 7.82237 8.20958 9.90178 5.64449 9.90178C3.07941 9.90178 1 7.82237 1 5.25729C1 2.6922 3.07941 0.612793 5.64449 0.612793C8.20958 0.612793 10.289 2.6922 10.289 5.25729Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'SearchIcon',
)

export const ChangeViewModeIcon = createSvgIcon(
  <svg viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.9598 10.3946C17.682 13.0045 16.2032 15.4503 13.7562 16.863C9.69075 19.2102 4.49223 17.8173 2.14502 13.7518L1.89502 13.3188M1.05297 8.60859C1.33077 5.9987 2.80956 3.55297 5.25654 2.1402C9.32203 -0.207007 14.5205 1.18593 16.8678 5.25142L17.1178 5.68443M1 15.5676L1.73205 12.8356L4.4641 13.5676M14.5492 5.4356L17.2813 6.16765L18.0133 3.4356'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'ChangeViewModeIcon',
)

export const PlusIcon = createSvgIcon(
  <svg viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9 0.75V9M9 9V17.25M9 9H0.75M9 9H17.25'
      stroke='currentColor'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </svg>,
  'PlusIcon',
)

export const MinusIcon = createSvgIcon(
  <svg viewBox='0 0 18 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.75 1H9H17.25'
      stroke='currentColor'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </svg>,
  'MinusIcon',
)
//#endregion

//#region Tools
export const SortIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='12'
    viewBox='0 0 16 12'
    fill='none'
  >
    <path
      d='M1 9.23529H5.94118M1 5.11765H8.41176M12.5294 4.29412V10.8824M12.5294 10.8824L15 8.41176M12.5294 10.8824L10.0588 8.41176M1 1H10.8824'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const CollapseIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
  >
    <path d='M3.33333 0.000163224L3.33333 3.3335L0 3.3335' stroke={color} />
    <path d='M6 9.3335L6 6.00016L9.33333 6.00016' stroke={color} />
  </svg>
)

export const VisibilityIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 16' fill='none'>
    <path
      d='M9.82824 1.26221C6.21158 1.26221 3.5101 3.6112 1.90395 5.53528C0.698684 6.97911 0.698683 9.02094 1.90395 10.4648C3.5101 12.3889 6.21157 14.7379 9.82824 14.7379C13.4449 14.7379 16.1464 12.3889 17.7525 10.4648C18.9578 9.02094 18.9578 6.97911 17.7525 5.53528C16.1464 3.61121 13.4449 1.26221 9.82824 1.26221Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.82823 10.8877C11.423 10.8877 12.7159 9.59483 12.7159 8.00003C12.7159 6.40523 11.423 5.11239 9.82823 5.11239C8.23344 5.11239 6.9406 6.40523 6.9406 8.00003C6.9406 9.59483 8.23344 10.8877 9.82823 10.8877Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'VisibilityIcon',
)

export const ListElementIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11' fill='none'>
    <path
      d='M1.13666 1V1.7875C1.13666 3.67768 1.13666 4.62277 1.50574 5.34472C1.83039 5.97977 2.34842 6.49607 2.98558 6.81965C3.70994 7.1875 4.65818 7.1875 6.55466 7.1875H10.1667M10.1667 7.1875L7.34478 4.375M10.1667 7.1875L7.34478 10'
      stroke='currentColor'
      strokeLinecap='square'
    />
  </svg>,
  'ListElementIcon',
)

export const ListShowMoreIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10' fill='none'>
    <path
      d='M0.925781 9L4.85351 5.07227L0.925781 1.14454'
      stroke='currentColor'
      strokeMiterlimit='10'
    />
  </svg>,
  'ListShowMoreIcon',
)

export const ArrowDownIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='6'
    viewBox='0 0 10 6'
    fill='none'
  >
    <path
      d='M1 0.927734L4.92773 4.85546L8.85546 0.927734'
      stroke={color}
      strokeMiterlimit='10'
    />
  </svg>
)

export const AddIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
  >
    <path
      d='M3.8125 16.0001C2.2592 16.0001 1 14.7409 1 13.1876V3.8125C1 2.2592 2.2592 1 3.8125 1H13.1875C14.7408 1 16 2.2592 16 3.8125L16 13.1876C16 14.7409 14.7408 16.0001 13.1875 16.0001H3.8125Z'
      stroke={color}
      strokeLinecap='round'
    />
    <path
      d='M12 8.5H8.5M8.5 8.5H5M8.5 8.5V12M8.5 8.5L8.5 5'
      stroke={color}
      strokeLinecap='round'
    />
  </svg>
)

export const FilterIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='19'
    height='12'
    viewBox='0 0 19 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 11H7M1 6H10M15 3V11M15 11L18 8M15 11L12 8M1 1H13'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
//#endregion

//#region Header Icons
export const AIIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='20'
    viewBox='0 0 19 20'
    fill='none'
  >
    <path
      d='M10.2615 0.609421C9.81633 0.253164 9.18367 0.253164 8.73853 0.609421L0.457172 7.23721C0.168205 7.46848 0 7.81854 0 8.18865V18.7814C0 19.4544 0.545603 20 1.21864 20H17.7814C18.4544 20 19 19.4544 19 18.7814V8.18865C19 7.81854 18.8318 7.46848 18.5428 7.23721L10.2615 0.609421Z'
      fill='url(#paint0_linear_4082_379)'
    />
    <path
      d='M9.86753 17.3288C10.062 17.3288 10.201 17.1985 10.2288 16.9844C10.5251 14.471 10.6456 14.3965 13.1927 13.9962C13.4242 13.959 13.5632 13.8379 13.5632 13.6332C13.5632 13.4377 13.4242 13.3073 13.239 13.2701C10.6548 12.7674 10.5251 12.786 10.2288 10.2819C10.201 10.0678 10.062 9.9375 9.86753 9.9375C9.67302 9.9375 9.53408 10.0678 9.5063 10.2726C9.19138 12.8233 9.09876 12.9164 6.50532 13.2701C6.32007 13.2887 6.17188 13.4377 6.17188 13.6332C6.17188 13.8286 6.31081 13.959 6.49606 13.9962C9.10802 14.4989 9.18212 14.4989 9.5063 17.003C9.53408 17.1985 9.67302 17.3288 9.86753 17.3288Z'
      fill={color}
    />
    <path
      d='M6.9127 10.677C7.02941 10.677 7.11277 10.5988 7.12944 10.4703C7.30728 8.96226 7.37952 8.91758 8.9078 8.67741C9.04673 8.65507 9.1301 8.58246 9.1301 8.45958C9.1301 8.34229 9.04673 8.26409 8.93559 8.24175C7.38508 7.94014 7.30728 7.95131 7.12944 6.44885C7.11277 6.32038 7.02941 6.24219 6.9127 6.24219C6.796 6.24219 6.71264 6.32038 6.69597 6.44326C6.50702 7.97365 6.45144 8.02951 4.89538 8.24175C4.78423 8.25292 4.69531 8.34229 4.69531 8.45958C4.69531 8.57687 4.77867 8.65507 4.88982 8.67741C6.457 8.97902 6.50146 8.97902 6.69597 10.4815C6.71264 10.5988 6.796 10.677 6.9127 10.677Z'
      fill={color}
    />
    <path
      d='M13.5642 12.1557C13.642 12.1557 13.6976 12.1036 13.7087 12.018C13.8272 11.0126 13.8754 10.9828 14.8943 10.8227C14.9869 10.8078 15.0425 10.7594 15.0425 10.6775C15.0425 10.5993 14.9869 10.5472 14.9128 10.5323C13.8791 10.3312 13.8272 10.3386 13.7087 9.33699C13.6976 9.25135 13.642 9.19922 13.5642 9.19922C13.4864 9.19922 13.4308 9.25135 13.4197 9.33327C13.2937 10.3535 13.2567 10.3908 12.2193 10.5323C12.1452 10.5397 12.0859 10.5993 12.0859 10.6775C12.0859 10.7557 12.1415 10.8078 12.2156 10.8227C13.2604 11.0238 13.29 11.0238 13.4197 12.0254C13.4308 12.1036 13.4864 12.1557 13.5642 12.1557Z'
      fill={color}
    />
    <defs>
      <linearGradient
        id='paint0_linear_4082_379'
        x1='15'
        y1='3'
        x2='1'
        y2='22.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#3D8BFF' />
        <stop offset='1' stopColor='#8CBAFF' />
      </linearGradient>
    </defs>
  </svg>
)
//#endregion

//#region Upload File
export const SpacialLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='124'
      height='25'
      viewBox='0 0 124 25'
      fill='none'
    >
      <path
        d='M23.9956 6.61642L19.2361 3.40849C19.2361 3.40849 19.2256 3.40066 19.219 3.39675C19.1012 3.32627 18.9532 3.32236 18.8328 3.38631L14.6506 5.60236V0.422433C14.6506 0.285398 14.5786 0.157499 14.4594 0.0870235C14.3416 0.0165482 14.1936 0.0126329 14.0732 0.0765827L0.208191 7.42428C0.079872 7.49214 0 7.62526 0 7.77013V17.3456C0 17.4827 0.0720157 17.6106 0.18986 17.681C0.18986 17.681 0.191169 17.681 0.192478 17.681L0.1676 17.7176L4.92719 21.0273L4.95206 20.9908C5.0136 21.0273 5.083 21.0456 5.15109 21.0456C5.21394 21.0456 5.2781 21.0299 5.33571 20.9999L9.51786 18.7838V23.8607C9.51786 23.9977 9.58988 24.1256 9.70903 24.1961C9.77057 24.2339 9.84128 24.2522 9.91067 24.2522C9.97353 24.2522 10.0377 24.2365 10.0953 24.2065L23.9616 16.8588C24.0899 16.791 24.1698 16.6578 24.1698 16.513V6.94009C24.1698 6.80958 24.103 6.68951 23.9956 6.61773V6.61642ZM19.4102 13.1001V9.69645L23.3842 7.59133V15.7782L19.4102 13.1001ZM19.4102 8.81029V4.47084L23.0162 6.89963L19.4102 8.81029ZM13.8663 6.01869L5.1799 10.6218L1.1444 7.8145L13.8663 1.07368V6.01869ZM0.785626 16.6931V8.52056L4.75958 11.2848V14.588L0.785626 16.6931ZM4.75958 15.4754V19.9571L1.1025 17.4135L4.75958 15.4754ZM13.8663 6.90616V9.76301L5.54521 14.1729V11.3161L13.8663 6.90616ZM5.54521 20.0041V15.0591L14.4437 10.3438C14.5721 10.2759 14.6519 10.1428 14.6519 9.99793V6.48983L18.6259 4.38471V9.22662L9.72736 13.9419C9.59904 14.0098 9.51917 14.1429 9.51917 14.2878V17.899L5.54521 20.0041ZM18.6246 10.1128V13.0727L10.3035 17.4827V14.5227L18.6246 10.1141V10.1128ZM10.3035 18.3688L18.9938 13.7644L23.0162 16.4751L10.3035 23.2107V18.3688Z'
        fill='#1705E5'
      />
      <path
        d='M42.2877 13.0675C41.9145 12.7725 41.4785 12.5311 40.9181 12.3105C40.0879 11.9829 39.2106 11.7728 38.3621 11.5705C38.171 11.5248 37.9785 11.4792 37.7873 11.4322C36.8826 11.209 35.949 10.9597 34.9342 10.6687C34.4615 10.533 34.0229 10.3189 33.6327 10.0318C33.2202 9.72902 32.9911 9.37664 32.9309 8.95771C32.7685 7.8301 33.1089 6.90871 33.943 6.21831C34.3882 5.84897 34.9303 5.59578 35.5994 5.44308C36.0943 5.33084 36.6128 5.27342 37.1405 5.27342C37.5045 5.27342 37.8829 5.30083 38.2666 5.35433C39.9871 5.59447 41.1485 6.37753 41.8189 7.74788C41.8647 7.84185 41.866 7.84837 41.8778 7.88883L41.8883 7.92407L41.9027 7.97236H41.9525C42.0546 7.96844 42.1829 7.96844 42.3571 7.96844C42.4906 7.96844 42.6333 7.96844 42.7721 7.96844C42.907 7.96844 43.0379 7.96844 43.1584 7.96844H43.2487L43.2199 7.88231C43.2003 7.82097 43.182 7.76615 43.1663 7.71526C43.1361 7.61868 43.1099 7.53515 43.0772 7.45424C42.5116 6.01341 41.4392 5.00196 39.8928 4.44729C39.2957 4.23326 38.6319 4.10144 37.8646 4.04271C37.6001 4.02314 37.3395 4.0127 37.0921 4.0127C35.9935 4.0127 35.035 4.20715 34.159 4.60521C32.6939 5.27342 31.8362 6.33707 31.611 7.76615C31.4473 8.80632 31.611 9.65593 32.1125 10.3633C32.4516 10.8423 32.9322 11.2207 33.6235 11.5549C34.6226 12.0377 35.7067 12.3027 36.7555 12.5585C36.8616 12.5846 36.9664 12.6107 37.0724 12.6368C37.913 12.8443 39.0168 13.121 40.1075 13.4237C40.5632 13.5503 40.9861 13.7644 41.3659 14.0606C41.7272 14.3425 41.9577 14.6858 42.0533 15.0812C42.2445 15.8786 42.1489 16.6252 41.7665 17.2986C41.3973 17.9498 40.8081 18.4079 39.9635 18.6976C39.2682 18.9365 38.5245 19.0579 37.752 19.0579C37.2178 19.0579 36.6534 19.0004 36.0747 18.8856C34.2311 18.5228 33.0277 17.4408 32.4974 15.6685C32.4804 15.6098 32.4529 15.555 32.4307 15.5067C32.4202 15.4858 32.411 15.4662 32.4032 15.4466L32.3862 15.4075H31.1697L31.1606 15.4623C31.158 15.4793 31.1553 15.4923 31.1527 15.5041C31.1475 15.5276 31.1449 15.5471 31.1436 15.5667C31.1436 15.5954 31.1449 15.6268 31.1514 15.6555C31.5743 17.5165 32.5852 18.8268 34.1564 19.5499C35.2773 20.0654 36.4465 20.3264 37.6341 20.3264C38.5638 20.3264 39.5183 20.1659 40.4702 19.8487C42.3597 19.2184 43.4268 17.7906 43.4726 15.8264C43.5015 14.6231 43.1139 13.72 42.2877 13.0688V13.0675Z'
        fill='#1705E5'
      />
      <path
        d='M77.7075 7.16224C79.0221 5.92501 80.5763 5.29726 82.3283 5.29726C82.6308 5.29726 82.9437 5.31553 83.2579 5.35338C85.4237 5.60917 87.0944 6.70807 88.2244 8.61873C88.2938 8.73619 88.3593 8.85887 88.4221 8.97763C88.4522 9.03505 88.4824 9.09117 88.5125 9.14729L88.5308 9.18122H89.9449L89.9057 9.08987C89.9057 9.08987 89.8219 8.8941 89.8101 8.86931C88.942 6.77985 87.4519 5.32075 85.3791 4.53247C84.4586 4.1814 83.4923 4.00391 82.509 4.00391C81.9944 4.00391 81.4667 4.05219 80.939 4.14877C78.154 4.65515 76.1598 6.19386 75.0089 8.72053C74.3031 10.2736 74.1146 11.9689 74.4511 13.7608C74.9355 16.3475 76.3562 18.2556 78.6712 19.4288C79.8248 20.0135 81.0595 20.3098 82.3388 20.3098C82.9345 20.3098 83.5486 20.2445 84.164 20.1166C86.7998 19.5685 88.6945 18.0115 89.7917 15.4888C89.8297 15.4026 89.8454 15.3661 89.907 15.1925L89.9371 15.1051H88.5164L88.4981 15.1403C88.4981 15.1403 88.409 15.3126 88.3357 15.464C87.8879 16.3788 87.224 17.1554 86.3638 17.7727C85.2155 18.5962 83.9126 19.0151 82.492 19.0151C82.289 19.0151 82.0795 19.006 81.8713 18.989C79.6218 18.805 77.8751 17.7596 76.6823 15.879C75.7605 14.4264 75.441 12.7676 75.733 10.9483C75.9752 9.43833 76.639 8.16325 77.7062 7.15832L77.7075 7.16224Z'
        fill='#1705E5'
      />
      <path
        d='M123.936 18.7832H116.01C116.009 17.7274 115.983 4.4741 115.983 4.33576V4.27051H114.717V4.33576L114.736 19.963V20.0282H124V18.7832H123.935H123.936Z'
        fill='#1705E5'
      />
      <path
        d='M93.1094 4.27051H93.0439V4.33576L93.0623 19.9682V20.0335H93.1277H94.2433H94.3088V19.9682V4.33576V4.27051H94.2433H93.1094Z'
        fill='#1705E5'
      />
      <path
        d='M58.5181 8.765C58.3558 6.89349 57.4379 5.55576 55.792 4.78967C55.0195 4.43077 54.1252 4.25328 53.058 4.24675C52.7503 4.24545 52.385 4.24414 51.9896 4.24414C49.9312 4.24414 46.9995 4.26372 46.9707 4.26372H46.9053V4.32897L46.9302 19.9888V20.0541H46.9956L48.1518 20.0436H48.2173V19.9784C48.2173 19.9784 48.2133 8.18553 48.2133 5.52183H48.3233H50.3149C51.2616 5.52183 52.3104 5.52183 52.9978 5.52183C53.6486 5.52183 54.2352 5.60797 54.7903 5.78416C56.1665 6.21875 57.0778 7.37898 57.1682 8.81067C57.2166 9.56371 57.1381 10.1614 56.9246 10.6913C56.4323 11.909 55.466 12.6424 54.0532 12.8708C53.6551 12.9361 53.2531 12.9465 52.914 12.9478C52.241 12.9517 51.0927 12.9531 50.4681 12.9531H50.07H50.0046V14.232H50.07C50.07 14.232 50.3372 14.232 50.7234 14.232C51.4318 14.232 52.4033 14.2307 53.0083 14.2216C53.6525 14.2125 54.1946 14.1577 54.6686 14.0559C56.1783 13.7296 57.2886 12.9113 57.9695 11.6245C58.4239 10.767 58.6085 9.80385 58.5181 8.76369V8.765Z'
        fill='#1705E5'
      />
      <path
        d='M66.6494 4.2846L66.6324 4.24414H64.9669L64.9498 4.2846L58.4501 19.9458L58.4121 20.0358H59.8262L59.8433 19.9954C59.8969 19.8648 65.0454 7.31764 65.7957 5.65756C66.3299 6.95483 66.8838 8.27428 67.418 9.55197C67.9679 10.8649 68.5362 12.2222 69.094 13.5743H64.2755L64.2585 13.6147L63.7989 14.7449L63.7622 14.835H63.8591L69.6138 14.8546L71.7494 20.0045L71.7664 20.0449H73.1832L73.1452 19.9549L66.6468 4.28851L66.6494 4.2846Z'
        fill='#1705E5'
      />
      <path
        d='M105.398 4.2846L105.381 4.24414H103.716L103.699 4.2846L97.1991 19.9458L97.1611 20.0358H98.5753L98.5923 19.9954C98.646 19.8648 103.794 7.31764 104.545 5.65756C105.079 6.95483 105.633 8.27428 106.167 9.55197C106.717 10.8649 107.285 12.2222 107.843 13.5743H103.025L103.008 13.6147L102.548 14.7449L102.511 14.835H102.608L108.363 14.8546L110.498 20.0045L110.515 20.0449H111.932L111.894 19.9549L105.396 4.28851L105.398 4.2846Z'
        fill='#1705E5'
      />
    </svg>
  )
}

export const FloorplansIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_2228_514)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.8295 4.06656H1.9732C1.7118 4.06656 1.4611 4.16494 1.27626 4.34005C1.09142 4.51516 0.987578 4.75267 0.987578 5.00031V12.4703L3.59554 10.2723C3.6761 10.1962 3.78194 10.1489 3.89511 10.1384C4.00828 10.1278 4.12183 10.1547 4.21649 10.2144L6.83825 11.8699L10.4949 8.4057C10.568 8.33639 10.6623 8.29062 10.7643 8.27487C10.8664 8.25911 10.9711 8.27418 11.0636 8.31793L12.8151 10.1359V5.00031C12.8151 4.75267 12.7112 4.51516 12.5264 4.34005C12.3416 4.16494 12.0909 4.06656 11.8295 4.06656ZM1.9732 3.13281C1.4504 3.13281 0.949 3.32957 0.579319 3.67979C0.209638 4.03001 0.00195313 4.50502 0.00195312 5.00031V12.4703C0.00195313 12.9656 0.209638 13.4406 0.579319 13.7908C0.949 14.1411 1.4504 14.3378 1.9732 14.3378H11.8295C12.3523 14.3378 12.8537 14.1411 13.2233 13.7908C13.593 13.4406 13.8007 12.9656 13.8007 12.4703V5.00031C13.8007 4.50502 13.593 4.03001 13.2233 3.67979C12.8537 3.32957 12.3523 3.13281 11.8295 3.13281H1.9732ZM5.9157 7.33469C5.9157 7.51862 5.87746 7.70075 5.80316 7.87068C5.72887 8.04062 5.61996 8.19502 5.48268 8.32508C5.34539 8.45514 5.18241 8.55831 5.00304 8.6287C4.82367 8.69908 4.63142 8.73531 4.43727 8.73531C4.24311 8.73531 4.05086 8.69908 3.87149 8.6287C3.69212 8.55831 3.52914 8.45514 3.39185 8.32508C3.25457 8.19502 3.14567 8.04062 3.07137 7.87068C2.99707 7.70075 2.95883 7.51862 2.95883 7.33469C2.95883 6.96322 3.11459 6.60696 3.39185 6.3443C3.66911 6.08163 4.04516 5.93406 4.43727 5.93406C4.82937 5.93406 5.20542 6.08163 5.48268 6.3443C5.75994 6.60696 5.9157 6.96322 5.9157 7.33469Z'
          fill='#1705E5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.94293 2.19937H13.7992C14.0606 2.19937 14.3113 2.29775 14.4961 2.47286C14.681 2.64798 14.7848 2.88548 14.7848 3.13312V10.6031C14.7848 10.8508 14.681 11.0883 14.4961 11.2634C14.3113 11.4385 14.0606 11.5369 13.7992 11.5369V12.4706C14.322 12.4706 14.8234 12.2739 15.1931 11.9236C15.5627 11.5734 15.7704 11.0984 15.7704 10.6031V3.13312C15.7704 2.63783 15.5627 2.16283 15.1931 1.8126C14.8234 1.46238 14.322 1.26563 13.7992 1.26562H3.94293C3.42012 1.26563 2.91873 1.46238 2.54905 1.8126C2.17936 2.16283 1.97168 2.63783 1.97168 3.13312H2.9573C2.9573 2.88548 3.06115 2.64798 3.24599 2.47286C3.43083 2.29775 3.68153 2.19937 3.94293 2.19937Z'
          fill='#1705E5'
        />
      </g>
      <defs>
        <clipPath id='clip0_2228_514'>
          <rect
            width='15.77'
            height='14.94'
            fill='white'
            transform='translate(0 0.332031)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ElevationsIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_2228_518)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.8285 4.06656H1.97223C1.71082 4.06656 1.46012 4.16494 1.27528 4.34005C1.09044 4.51516 0.986602 4.75267 0.986602 5.00031V12.4703L3.59457 10.2723C3.67512 10.1962 3.78096 10.1489 3.89413 10.1384C4.00731 10.1278 4.12085 10.1547 4.21551 10.2144L6.83727 11.8699L10.4939 8.4057C10.567 8.33639 10.6613 8.29062 10.7633 8.27487C10.8654 8.25911 10.9701 8.27418 11.0626 8.31793L12.8141 10.1359V5.00031C12.8141 4.75267 12.7103 4.51516 12.5254 4.34005C12.3406 4.16494 12.0899 4.06656 11.8285 4.06656ZM1.97223 3.13281C1.44942 3.13281 0.948023 3.32957 0.578342 3.67979C0.208661 4.03001 0.000976563 4.50502 0.000976562 5.00031V12.4703C0.000976563 12.9656 0.208661 13.4406 0.578342 13.7908C0.948023 14.1411 1.44942 14.3378 1.97223 14.3378H11.8285C12.3513 14.3378 12.8527 14.1411 13.2224 13.7908C13.592 13.4406 13.7997 12.9656 13.7997 12.4703V5.00031C13.7997 4.50502 13.592 4.03001 13.2224 3.67979C12.8527 3.32957 12.3513 3.13281 11.8285 3.13281H1.97223ZM5.91473 7.33469C5.91473 7.51862 5.87649 7.70075 5.80219 7.87068C5.72789 8.04062 5.61899 8.19502 5.4817 8.32508C5.34442 8.45514 5.18143 8.55831 5.00206 8.6287C4.82269 8.69908 4.63044 8.73531 4.43629 8.73531C4.24214 8.73531 4.04989 8.69908 3.87052 8.6287C3.69114 8.55831 3.52816 8.45514 3.39088 8.32508C3.25359 8.19502 3.14469 8.04062 3.07039 7.87068C2.99609 7.70075 2.95785 7.51862 2.95785 7.33469C2.95785 6.96322 3.11361 6.60696 3.39088 6.3443C3.66814 6.08163 4.04418 5.93406 4.43629 5.93406C4.82839 5.93406 5.20444 6.08163 5.4817 6.3443C5.75896 6.60696 5.91473 6.96322 5.91473 7.33469Z'
          fill='#1705E5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.94195 2.19937H13.7982C14.0596 2.19937 14.3103 2.29775 14.4951 2.47286C14.68 2.64798 14.7838 2.88548 14.7838 3.13312V10.6031C14.7838 10.8508 14.68 11.0883 14.4951 11.2634C14.3103 11.4385 14.0596 11.5369 13.7982 11.5369V12.4706C14.321 12.4706 14.8224 12.2739 15.1921 11.9236C15.5618 11.5734 15.7695 11.0984 15.7695 10.6031V3.13312C15.7695 2.63783 15.5618 2.16283 15.1921 1.8126C14.8224 1.46238 14.321 1.26563 13.7982 1.26562H3.94195C3.41915 1.26563 2.91775 1.46238 2.54807 1.8126C2.17839 2.16283 1.9707 2.63783 1.9707 3.13312H2.95633C2.95633 2.88548 3.06017 2.64798 3.24501 2.47286C3.42985 2.29775 3.68055 2.19937 3.94195 2.19937Z'
          fill='#1705E5'
        />
      </g>
      <defs>
        <clipPath id='clip0_2228_518'>
          <rect
            width='15.77'
            height='14.94'
            fill='white'
            transform='translate(0 0.332031)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SurveyIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='16'
      viewBox='0 0 15 16'
      fill='none'
    >
      <path
        d='M2.92609 0.0259375H12.6786C13.189 0.0259375 13.6785 0.228703 14.0395 0.589629C14.4004 0.950554 14.6031 1.44007 14.6031 1.9505V13.6535C14.6031 14.1639 14.4004 14.6534 14.0395 15.0144C13.6785 15.3753 13.189 15.5781 12.6786 15.5781H2.92609C2.41566 15.5781 1.92614 15.3753 1.56521 15.0144C1.20429 14.6534 1.00152 14.1639 1.00152 13.6535V12.7042H1.9249V13.6535C1.9249 13.919 2.03038 14.1737 2.21814 14.3614C2.4059 14.5492 2.66055 14.6547 2.92609 14.6547H12.6786C12.9441 14.6547 13.1988 14.5492 13.3865 14.3614C13.5743 14.1737 13.6798 13.919 13.6798 13.6535V1.9505C13.6798 1.68497 13.5743 1.43031 13.3865 1.24255C13.1988 1.05479 12.9441 0.949312 12.6786 0.949312H2.92609C2.66055 0.949312 2.4059 1.05479 2.21814 1.24255C2.03038 1.43031 1.9249 1.68497 1.9249 1.9505V2.89981H1.00152V1.9505C1.00152 1.44007 1.20429 0.950554 1.56521 0.589629C1.92614 0.228703 2.41566 0.0259375 2.92609 0.0259375Z'
        fill='#1705E5'
        stroke='#1705E5'
        strokeWidth='0.051875'
      />
      <path
        d='M0.97525 4.90158H1.00119V4.87564V4.38802C1.00119 4.26557 1.04983 4.14814 1.13641 4.06155C1.223 3.97497 1.34043 3.92633 1.46288 3.92633C1.58532 3.92633 1.70275 3.97497 1.78934 4.06155C1.87592 4.14814 1.92456 4.26557 1.92456 4.38802V4.87564V4.90158H1.9505H2.43813C2.56057 4.90158 2.678 4.95022 2.76459 5.0368C2.85117 5.12339 2.89981 5.24082 2.89981 5.36327C2.89981 5.48571 2.85117 5.60314 2.76459 5.68973C2.678 5.77631 2.56057 5.82495 2.43813 5.82495H0.487625C0.365178 5.82495 0.247746 5.77631 0.161163 5.68973C0.0745794 5.60314 0.0259375 5.48571 0.0259375 5.36327C0.0259375 5.24082 0.0745794 5.12339 0.161163 5.0368C0.247746 4.95022 0.365178 4.90158 0.487625 4.90158H0.97525ZM0.97525 7.82733H1.00119V7.80139V7.31377C1.00119 7.19132 1.04983 7.07389 1.13641 6.9873C1.223 6.90072 1.34043 6.85208 1.46288 6.85208C1.58532 6.85208 1.70275 6.90072 1.78934 6.9873C1.87592 7.07389 1.92456 7.19132 1.92456 7.31377V7.80139V7.82733H1.9505H2.43813C2.56057 7.82733 2.678 7.87597 2.76459 7.96255C2.85117 8.04914 2.89981 8.16657 2.89981 8.28902C2.89981 8.41146 2.85117 8.52889 2.76459 8.61548C2.678 8.70206 2.56057 8.7507 2.43813 8.7507H0.487625C0.365178 8.7507 0.247746 8.70206 0.161163 8.61548C0.0745795 8.52889 0.0259375 8.41146 0.0259375 8.28902C0.0259375 8.16657 0.0745795 8.04914 0.161163 7.96255C0.247746 7.87597 0.365178 7.82733 0.487625 7.82733H0.97525ZM0.97525 10.7531H1.00119V10.7271V10.2395C1.00119 10.1171 1.04983 9.99964 1.13641 9.91305C1.223 9.82647 1.34043 9.77783 1.46288 9.77783C1.58532 9.77783 1.70275 9.82647 1.78934 9.91305C1.87592 9.99964 1.92456 10.1171 1.92456 10.2395V10.7271V10.7531H1.9505H2.43813C2.56057 10.7531 2.678 10.8017 2.76459 10.8883C2.85117 10.9749 2.89981 11.0923 2.89981 11.2148C2.89981 11.3372 2.85117 11.4546 2.76459 11.5412C2.678 11.6278 2.56057 11.6765 2.43813 11.6765H0.487625C0.365178 11.6765 0.247746 11.6278 0.161163 11.5412C0.0745795 11.4546 0.0259375 11.3372 0.0259375 11.2148C0.0259375 11.0923 0.0745794 10.9749 0.161163 10.8883C0.247746 10.8017 0.365178 10.7531 0.487625 10.7531H0.97525Z'
        fill='#1705E5'
        stroke='#1705E5'
        strokeWidth='0.051875'
      />
      <line
        x1='4.55078'
        y1='3.72078'
        x2='11.7026'
        y2='3.72078'
        stroke='#1705E5'
        strokeWidth='1.66'
      />
      <line
        x1='4.55078'
        y1='6.32137'
        x2='11.7026'
        y2='6.32137'
        stroke='#1705E5'
        strokeWidth='1.66'
      />
      <line
        x1='4.55078'
        y1='8.92195'
        x2='11.7026'
        y2='8.92195'
        stroke='#1705E5'
        strokeWidth='1.66'
      />
      <line
        x1='4.55078'
        y1='11.5235'
        x2='9.75211'
        y2='11.5235'
        stroke='#1705E5'
        strokeWidth='1.66'
      />
    </svg>
  )
}

export const GeoReportIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_2228_522)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.97125 1.26578H13.7987C14.0602 1.26578 14.3109 1.36416 14.4957 1.53927C14.6805 1.71438 14.7844 1.95189 14.7844 2.19953V13.4045C14.7844 13.6522 14.6805 13.8897 14.4957 14.0648C14.3109 14.2399 14.0602 14.3383 13.7987 14.3383H1.97125C1.70985 14.3383 1.45915 14.2399 1.27431 14.0648C1.08947 13.8897 0.985625 13.6522 0.985625 13.4045V2.19953C0.985625 1.95189 1.08947 1.71438 1.27431 1.53927C1.45915 1.36416 1.70985 1.26578 1.97125 1.26578ZM13.7987 0.332031C14.3216 0.332031 14.823 0.528785 15.1926 0.879009C15.5623 1.22923 15.77 1.70424 15.77 2.19953V13.4045C15.77 13.8998 15.5623 14.3748 15.1926 14.7251C14.823 15.0753 14.3216 15.272 13.7987 15.272H1.97125C1.44844 15.272 0.947047 15.0753 0.577366 14.7251C0.207685 14.3748 0 13.8998 0 13.4045V2.19953C0 1.70424 0.207685 1.22923 0.577366 0.879009C0.947047 0.528785 1.44844 0.332031 1.97125 0.332031L13.7987 0.332031Z'
          fill='#1705E5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.92801 14.3381V1.26562H3.94238V14.3381H4.92801ZM12.813 3.6C12.813 3.47618 12.7611 3.35743 12.6687 3.26987C12.5762 3.18231 12.4509 3.13313 12.3202 3.13313H7.39207C7.26137 3.13313 7.13602 3.18231 7.0436 3.26987C6.95118 3.35743 6.89926 3.47618 6.89926 3.6C6.89926 3.72382 6.95118 3.84257 7.0436 3.93013C7.13602 4.01769 7.26137 4.06687 7.39207 4.06687H12.3202C12.4509 4.06687 12.5762 4.01769 12.6687 3.93013C12.7611 3.84257 12.813 3.72382 12.813 3.6ZM12.813 6.40125C12.813 6.27743 12.7611 6.15868 12.6687 6.07112C12.5762 5.98356 12.4509 5.93438 12.3202 5.93438H7.39207C7.26137 5.93438 7.13602 5.98356 7.0436 6.07112C6.95118 6.15868 6.89926 6.27743 6.89926 6.40125C6.89926 6.52507 6.95118 6.64382 7.0436 6.73138C7.13602 6.81894 7.26137 6.86812 7.39207 6.86812H12.3202C12.4509 6.86812 12.5762 6.81894 12.6687 6.73138C12.7611 6.64382 12.813 6.52507 12.813 6.40125ZM12.813 9.2025C12.813 9.07868 12.7611 8.95993 12.6687 8.87237C12.5762 8.78481 12.4509 8.73563 12.3202 8.73563H7.39207C7.26137 8.73563 7.13602 8.78481 7.0436 8.87237C6.95118 8.95993 6.89926 9.07868 6.89926 9.2025C6.89926 9.32632 6.95118 9.44508 7.0436 9.53263C7.13602 9.62019 7.26137 9.66938 7.39207 9.66938H12.3202C12.4509 9.66938 12.5762 9.62019 12.6687 9.53263C12.7611 9.44508 12.813 9.32632 12.813 9.2025ZM12.813 12.0038C12.813 11.8799 12.7611 11.7612 12.6687 11.6736C12.5762 11.5861 12.4509 11.5369 12.3202 11.5369H7.39207C7.26137 11.5369 7.13602 11.5861 7.0436 11.6736C6.95118 11.7612 6.89926 11.8799 6.89926 12.0038C6.89926 12.1276 6.95118 12.2463 7.0436 12.3339C7.13602 12.4214 7.26137 12.4706 7.39207 12.4706H12.3202C12.4509 12.4706 12.5762 12.4214 12.6687 12.3339C12.7611 12.2463 12.813 12.1276 12.813 12.0038Z'
          fill='#1705E5'
        />
      </g>
      <rect
        x='0.415'
        y='0.747031'
        width='14.94'
        height='14.11'
        stroke='#1705E5'
        strokeWidth='0.83'
      />
      <defs>
        <clipPath id='clip0_2228_522'>
          <rect y='0.332031' width='15.77' height='14.94' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const UploadPdfIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.751 4.97389H2.62598C2.27788 4.97389 1.94404 5.10489 1.6979 5.33808C1.45176 5.57127 1.31348 5.88753 1.31348 6.21731V16.1647L4.78635 13.2377C4.89363 13.1364 5.03456 13.0734 5.18527 13.0594C5.33598 13.0453 5.48717 13.0811 5.61323 13.1606L9.10448 15.3652L13.9739 10.7521C14.0712 10.6598 14.1967 10.5988 14.3326 10.5778C14.4685 10.5569 14.608 10.5769 14.7312 10.6352L17.0635 13.0561V6.21731C17.0635 5.88753 16.9252 5.57127 16.6791 5.33808C16.4329 5.10489 16.0991 4.97389 15.751 4.97389ZM2.62598 3.73047C1.92978 3.73047 1.2621 3.99247 0.769821 4.45885C0.277538 4.92522 0.000976563 5.55776 0.000976562 6.21731V16.1647C0.000976563 16.8242 0.277538 17.4568 0.769821 17.9231C1.2621 18.3895 1.92978 18.6515 2.62598 18.6515H15.751C16.4472 18.6515 17.1148 18.3895 17.6071 17.9231C18.0994 17.4568 18.376 16.8242 18.376 16.1647V6.21731C18.376 5.55776 18.0994 4.92522 17.6071 4.45885C17.1148 3.99247 16.4472 3.73047 15.751 3.73047H2.62598ZM7.87598 9.32586C7.87598 9.5708 7.82505 9.81333 7.72611 10.0396C7.62718 10.2659 7.48216 10.4715 7.29934 10.6447C7.11653 10.8179 6.89949 10.9553 6.66063 11.049C6.42177 11.1428 6.16577 11.191 5.90723 11.191C5.64869 11.191 5.39268 11.1428 5.15382 11.049C4.91496 10.9553 4.69793 10.8179 4.51511 10.6447C4.33229 10.4715 4.18728 10.2659 4.08834 10.0396C3.9894 9.81333 3.93848 9.5708 3.93848 9.32586C3.93848 8.8312 4.1459 8.3568 4.51511 8.00702C4.88432 7.65724 5.38508 7.46073 5.90723 7.46073C6.42937 7.46073 6.93013 7.65724 7.29934 8.00702C7.66856 8.3568 7.87598 8.8312 7.87598 9.32586Z'
      fill={color}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.24902 2.48659H18.374C18.7221 2.48659 19.056 2.61759 19.3021 2.85077C19.5482 3.08396 19.6865 3.40023 19.6865 3.73001V13.6774C19.6865 14.0071 19.5482 14.3234 19.3021 14.5566C19.056 14.7898 18.7221 14.9208 18.374 14.9208V16.1642C19.0702 16.1642 19.7379 15.9022 20.2302 15.4358C20.7225 14.9695 20.999 14.3369 20.999 13.6774V3.73001C20.999 3.07045 20.7225 2.43792 20.2302 1.97154C19.7379 1.50517 19.0702 1.24316 18.374 1.24316H5.24902C4.55283 1.24316 3.88515 1.50517 3.39287 1.97154C2.90059 2.43792 2.62402 3.07045 2.62402 3.73001H3.93652C3.93652 3.40023 4.0748 3.08396 4.32095 2.85077C4.56709 2.61759 4.90093 2.48659 5.24902 2.48659Z'
      fill={color}
    />
  </svg>
)

export const UploadIfcIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='19'
    height='20'
    viewBox='0 0 19 20'
    fill='none'
  >
    <path
      d='M3.67609 0.0259375H15.9286C16.5716 0.0259375 17.1883 0.281382 17.643 0.736075C18.0977 1.19077 18.3531 1.80747 18.3531 2.4505V17.1535C18.3531 17.7965 18.0977 18.4132 17.643 18.8679C17.1883 19.3226 16.5716 19.5781 15.9286 19.5781H3.67609C3.03305 19.5781 2.41636 19.3226 1.96166 18.8679C1.50697 18.4132 1.25152 17.7965 1.25152 17.1535V15.9542H2.4249V17.1535C2.4249 17.4853 2.55672 17.8036 2.79136 18.0382C3.02601 18.2729 3.34425 18.4047 3.67609 18.4047H15.9286C16.2604 18.4047 16.5787 18.2729 16.8133 18.0382C17.048 17.8036 17.1798 17.4853 17.1798 17.1535V2.4505C17.1798 2.11866 17.048 1.80042 16.8133 1.56578C16.5787 1.33113 16.2604 1.19931 15.9286 1.19931H3.67609C3.34425 1.19931 3.02601 1.33113 2.79136 1.56578C2.55672 1.80042 2.4249 2.11866 2.4249 2.4505V3.64981H1.25152V2.4505C1.25152 1.80747 1.50697 1.19077 1.96166 0.736075C2.41636 0.281382 3.03305 0.0259375 3.67609 0.0259375Z'
      fill={color}
      stroke={color}
      strokeWidth='0.051875'
    />
    <path
      d='M1.22525 6.15158H1.25119V6.12564V5.51302C1.25119 5.35742 1.313 5.20819 1.42302 5.09817C1.53305 4.98814 1.68228 4.92633 1.83788 4.92633C1.99347 4.92633 2.1427 4.98814 2.25273 5.09817C2.36275 5.20819 2.42456 5.35742 2.42456 5.51302V6.12564V6.15158H2.4505H3.06313C3.21872 6.15158 3.36795 6.21339 3.47798 6.32341C3.588 6.43344 3.64981 6.58267 3.64981 6.73827C3.64981 6.89386 3.588 7.04309 3.47798 7.15312C3.36795 7.26314 3.21872 7.32495 3.06313 7.32495H0.612625C0.457026 7.32495 0.3078 7.26314 0.197774 7.15312C0.087749 7.04309 0.0259375 6.89386 0.0259375 6.73827C0.0259375 6.58267 0.087749 6.43344 0.197774 6.32341C0.3078 6.21339 0.457026 6.15158 0.612625 6.15158H1.22525ZM1.22525 9.82733H1.25119V9.80139V9.18877C1.25119 9.03317 1.313 8.88394 1.42302 8.77391C1.53305 8.66389 1.68228 8.60208 1.83788 8.60208C1.99347 8.60208 2.1427 8.66389 2.25273 8.77391C2.36275 8.88394 2.42456 9.03317 2.42456 9.18877V9.80139V9.82733H2.4505H3.06313C3.21872 9.82733 3.36795 9.88914 3.47798 9.99916C3.588 10.1092 3.64981 10.2584 3.64981 10.414C3.64981 10.5696 3.588 10.7188 3.47798 10.8289C3.36795 10.9389 3.21872 11.0007 3.06313 11.0007H0.612625C0.457026 11.0007 0.307799 10.9389 0.197774 10.8289C0.0877491 10.7188 0.0259375 10.5696 0.0259375 10.414C0.0259375 10.2584 0.0877491 10.1092 0.197774 9.99916C0.307799 9.88914 0.457026 9.82733 0.612625 9.82733H1.22525ZM1.22525 13.5031H1.25119V13.4771V12.8645C1.25119 12.7089 1.313 12.5597 1.42302 12.4497C1.53305 12.3396 1.68228 12.2778 1.83788 12.2778C1.99347 12.2778 2.1427 12.3396 2.25273 12.4497C2.36275 12.5597 2.42456 12.7089 2.42456 12.8645V13.4771V13.5031H2.4505H3.06313C3.21872 13.5031 3.36795 13.5649 3.47798 13.6749C3.588 13.7849 3.64981 13.9342 3.64981 14.0898C3.64981 14.2454 3.588 14.3946 3.47798 14.5046C3.36795 14.6146 3.21872 14.6765 3.06313 14.6765H0.612625C0.457026 14.6765 0.307799 14.6146 0.197774 14.5046C0.087749 14.3946 0.0259375 14.2454 0.0259375 14.0898C0.0259375 13.9342 0.0877491 13.7849 0.197774 13.6749C0.3078 13.5649 0.457026 13.5031 0.612625 13.5031H1.22525Z'
      fill={color}
      stroke={color}
      strokeWidth='0.051875'
    />
    <line
      x1='5.71777'
      y1='4.8868'
      x2='14.7029'
      y2='4.8868'
      stroke={color}
      strokeWidth='1.66'
    />
    <line
      x1='5.71777'
      y1='8.15438'
      x2='14.7029'
      y2='8.15438'
      stroke={color}
      strokeWidth='1.66'
    />
    <line
      x1='5.71777'
      y1='11.421'
      x2='14.7029'
      y2='11.421'
      stroke={color}
      strokeWidth='1.66'
    />
    <line
      x1='5.71777'
      y1='14.6895'
      x2='12.2524'
      y2='14.6895'
      stroke={color}
      strokeWidth='1.66'
    />
  </svg>
)

export const UploadDxfIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='18'
    height='20'
    viewBox='0 0 18 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.9168 6.42519L8.98003 9.09384L4.04327 6.42519C3.59447 6.15833 3.05591 6.33624 2.78664 6.78101C2.60712 7.22579 2.69688 7.75952 3.14567 8.02638L8.08244 10.695V16.2103C8.08244 16.744 8.44148 17.0998 8.98003 17.0998C9.51859 17.0998 9.87763 16.744 9.87763 16.2103V10.695L14.8144 8.02638C15.2632 7.75952 15.4427 7.22579 15.1734 6.78101C14.9042 6.33624 14.3656 6.15833 13.9168 6.42519Z'
      fill={color}
    />
    <path
      d='M16.11 3.61839L10.71 0.471964C9.63 -0.157321 8.28 -0.157321 7.2 0.471964L1.89 3.61839C0.72 4.24767 0 5.59614 0 6.94461V12.8779C0 14.2263 0.72 15.5748 1.89 16.2041L7.29 19.3505C7.83 19.6202 8.37 19.8 9 19.8C9.63 19.8 10.17 19.6202 10.71 19.3505L16.11 16.2041C17.28 15.5748 18 14.2263 18 12.8779V6.94461C18 5.59614 17.28 4.24767 16.11 3.61839ZM16.2 12.8779C16.2 13.597 15.84 14.3162 15.21 14.6758L9.81 17.8222C9.27 18.0919 8.64 18.0919 8.1 17.8222L2.7 14.6758C2.07 14.3162 1.71 13.6869 1.71 12.8779V6.94461C1.71 6.22543 2.07 5.50624 2.7 5.14665L8.1 2.00023C8.46 1.91033 8.73 1.82043 9 1.82043C9.27 1.82043 9.54 1.91033 9.81 2.09012L15.21 5.23655C15.84 5.59614 16.2 6.22543 16.2 7.03451V12.8779Z'
      fill={color}
    />
  </svg>
)

export const AddFileIcon: React.FC<SvgIconProps> = ({ color }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M6 1H2C1.44771 1 1 1.44771 1 2V6'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 19H2C1.44771 19 1 18.5523 1 18V14'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 19H18C18.5523 19 19 18.5523 19 18V14'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 1H18C18.5523 1 19 1.44771 19 2V6'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14 10H6'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 14V6'
        stroke={color}
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ConvertFailedIcon = createSvgIcon(
  <svg
    width='88'
    height='54'
    viewBox='0 0 88 54'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M66.5611 4.78647C67.4861 4.71365 68.6053 5.20227 69.1707 5.92622C72.8761 12.6824 77.3623 19.2465 80.9404 26.0481C81.1388 26.4259 81.5345 27.1087 81.6013 27.4981C81.9089 29.2911 80.7463 30.9068 78.9291 31.1137L54.2334 31.0092C52.5477 30.4552 51.6832 28.7909 52.2019 27.0802L64.7227 5.59696C65.1608 5.17167 65.9511 4.83291 66.56 4.78436L66.5611 4.78647ZM65.9797 22.4347C66.7467 23.2958 67.9179 22.707 68.0536 21.5598C68.2308 20.0623 68.2202 18.3516 68.2785 16.8299C68.3337 15.3925 69.0413 12.0788 66.5356 12.4619C66.0996 12.5283 65.5024 13.0243 65.4218 13.4613C65.216 14.5746 65.479 16.5935 65.5268 17.7733C65.5788 19.0386 65.5119 20.6554 65.7411 21.8817C65.7708 22.0389 65.8758 22.3197 65.9797 22.4357V22.4347ZM66.3394 24.8081C64.8521 25.1458 64.8797 27.7271 66.6449 27.9382C69.1017 28.2326 68.8959 24.2266 66.3394 24.8081Z'
      fill='currentColor'
    />
    <path
      d='M40.4131 3.17965V11.2423L54.1082 19.7219C54.6131 20.2189 53.8334 21.0537 53.2383 20.7223L39.7395 12.4729L32.8908 17.4624C34.4884 18.4639 36.1953 19.3631 37.7557 20.4216C37.9424 20.5482 38.3137 20.7456 38.3784 20.9619L38.3445 29.8446C38.109 30.2108 37.7419 30.2424 37.3441 30.1052L25.1034 22.5037L15.3047 29.5839L23.2141 34.5703L29.5058 30.1116C29.8484 29.9406 30.3025 30.2488 30.4064 30.5791L30.3746 39.6232L23.9917 44.3395L32.7848 49.8736V40.7566C32.7848 40.6427 33.1911 40.2237 33.3237 40.1329L43.0397 33.0939L43.0683 24.5321C43.1945 23.9706 43.4173 23.73 44.0177 23.8873L50.2129 27.7413C51.2875 28.9433 50.0644 29.5438 49.1956 30.2066C44.2278 33.992 38.964 37.4292 34.0567 41.2854V50.4023L58.2899 32.9261C59.0495 32.8945 59.1131 33.458 58.8171 34.0342L34.167 51.9368C33.766 52.0982 33.4106 51.8217 33.0712 51.6466C31.9679 51.0746 30.7045 50.1723 29.6161 49.4979C21.9793 44.7658 14.4157 39.8786 6.87332 35.0178L6.71526 34.6484L6.72692 25.6898L6.88499 25.3193L39.749 1.62305L40.4895 1.68109L58.2973 12.7377C58.4968 13.3741 58.0205 13.8954 57.3946 13.6379L40.4131 3.17965ZM39.2472 3.60178L26.0062 13.0353L31.673 16.6372C34.2572 14.8917 36.783 13.0491 39.2472 11.1379V3.60178ZM24.4139 14.3524L8.73292 25.5768L14.0593 28.7797C17.5409 26.3166 21.0309 23.8387 24.4139 21.2563V14.3524ZM37.2338 28.3713V21.6785L25.6858 14.459V21.2574L36.8562 28.2732L37.2338 28.3713ZM49.1001 28.7914L48.8816 28.4304L44.3328 25.6317V32.0597L49.1001 28.7914ZM7.99248 26.6849V34.221L22.4036 43.3918L22.6137 43.2852V35.9074C22.6137 35.8547 22.4949 35.6847 22.4302 35.6394L7.99248 26.6849ZM23.7785 42.9158L29.1822 38.9636V31.9542C27.3598 33.2353 25.5002 34.5017 23.7785 35.9064V42.9158Z'
      fill='currentColor'
    />
  </svg>,
  'ConvertFailed',
)
//#endregion

//#region Start Validation Modal
export const StartValidationIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='17'
      viewBox='0 0 17 19'
      fill='none'
    >
      <path
        d='M8.24505 18.2054C8.55513 18.2054 8.77661 17.9977 8.8209 17.6564C9.29339 13.6497 9.48534 13.5309 13.5458 12.8928C13.9149 12.8335 14.1364 12.6406 14.1364 12.3141C14.1364 12.0025 13.9149 11.7947 13.6196 11.7353C9.50011 10.934 9.29339 10.9637 8.8209 6.9718C8.77661 6.63049 8.55513 6.42273 8.24505 6.42273C7.93498 6.42273 7.7135 6.63049 7.66921 6.95696C7.16719 11.023 7.01953 11.1714 2.88525 11.7353C2.58994 11.765 2.3537 12.0025 2.3537 12.3141C2.3537 12.6257 2.57518 12.8335 2.87048 12.8928C7.0343 13.6942 7.15242 13.6942 7.66921 17.6861C7.7135 17.9977 7.93498 18.2054 8.24505 18.2054Z'
        fill='white'
      />
      <path
        d='M3.53481 7.59892C3.72086 7.59892 3.85374 7.47427 3.88032 7.26948C4.16382 4.86545 4.27898 4.79422 6.71526 4.41136C6.93674 4.37574 7.06963 4.25999 7.06963 4.06411C7.06963 3.87713 6.93674 3.75248 6.75955 3.71686C4.28784 3.23606 4.16382 3.25386 3.88032 0.858738C3.85374 0.65395 3.72086 0.529297 3.53481 0.529297C3.34877 0.529297 3.21588 0.65395 3.18931 0.849834C2.88809 3.28948 2.7995 3.37852 0.318931 3.71686C0.141747 3.73467 0 3.87713 0 4.06411C0 4.25109 0.132888 4.37574 0.310071 4.41136C2.80836 4.89216 2.87923 4.89216 3.18931 7.28729C3.21588 7.47427 3.34877 7.59892 3.53481 7.59892Z'
        fill='white'
      />
      <path
        d='M14.1383 9.95893C14.2623 9.95893 14.3509 9.87583 14.3686 9.73931C14.5576 8.13662 14.6344 8.08913 16.2585 7.83389C16.4062 7.81015 16.4948 7.73298 16.4948 7.60239C16.4948 7.47774 16.4062 7.39464 16.2881 7.37089C14.6403 7.05036 14.5576 7.06223 14.3686 5.46548C14.3509 5.32895 14.2623 5.24585 14.1383 5.24585C14.0142 5.24585 13.9256 5.32895 13.9079 5.45954C13.7071 7.08597 13.648 7.14533 11.9943 7.37089C11.8762 7.38276 11.7817 7.47774 11.7817 7.60239C11.7817 7.72705 11.8703 7.81015 11.9884 7.83389C13.6539 8.15443 13.7012 8.15443 13.9079 9.75118C13.9256 9.87583 14.0142 9.95893 14.1383 9.95893Z'
        fill='white'
      />
    </svg>
  )
}
//#endregion

//#region Assign Project
export const AssignOrganizationLogo = () => (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='30' height='30' rx='15' fill='#FF3838' />
  </svg>
)

export const EngineerAvatar = () => (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect width='30' height='30' rx='15' fill='url(#pattern0_2451_9)' />
    <defs>
      <pattern
        id='pattern0_2451_9'
        patternContentUnits='objectBoundingBox'
        width='1'
        height='1'
      >
        <use xlinkHref='#image0_2451_9' transform='scale(0.0025)' />
      </pattern>
      <image
        id='image0_2451_9'
        width='400'
        height='400'
        preserveAspectRatio='none'
        xlinkHref='data:image/jpeg;base64,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'
      />
    </defs>
  </svg>
)

export const ArrowEngIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='8'
    height='13'
    viewBox='0 0 8 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.65625 12.3135L6.3131 6.65662L0.65625 0.999769'
      stroke={color}
      strokeMiterlimit='10'
    />
  </svg>
)
//#endregion

//#region Egnineering
export const MechanicalEngineeringIcon: React.FC<SvgIconProps> = ({
  color,
}) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99002 2.43057C9.98232 2.34155 9.78364 2.1706 9.69955 2.14011C9.61526 2.10943 9.52091 2.13031 9.45749 2.19338L8.18549 3.46538L6.5333 1.81319L7.83075 0.520622C7.89425 0.457428 7.91496 0.363408 7.88437 0.279579C7.85347 0.195584 7.64977 0.0176401 7.56022 0.00992837C6.77227 -0.0577054 6.00021 0.222563 5.44201 0.778744C4.67751 1.54043 4.47505 2.65271 4.83356 3.60079C4.79437 3.63368 4.75571 3.66853 4.71757 3.70611L0.386682 7.77739L0.381996 7.78196C-0.127332 8.28939 -0.127332 9.11502 0.381996 9.62253C0.891407 10.1299 1.71409 10.1238 2.22334 9.61632C2.22553 9.61428 2.22754 9.61224 2.22955 9.60997L6.28057 5.26179C6.3175 5.22484 6.35179 5.18617 6.38411 5.14649C7.33603 5.50429 8.45323 5.30308 9.2184 4.54089C9.77647 3.98467 10.058 3.21546 9.99002 2.43057Z'
      fill={color}
    />
  </svg>
)

export const StructuralEngineeringIcon: React.FC<SvgIconProps> = ({
  color,
}) => (
  <svg
    width='14'
    height='13'
    viewBox='0 0 14 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.6 0.95H4.55V1V3.03108H3.7H3.65V3.08108V3.67568V3.72568H3.7H4.55V5.75676V5.80676H4.6H5.2H5.25V5.75676V3.72568H6.65V5.75676V5.80676H6.7H7.3H7.35V5.75676V3.72568H8.75V5.75676V5.80676H8.8H9.4H9.45V5.75676V3.72568H10.3H10.35V3.67568V3.08108V3.03108H10.3H9.45V1V0.95H9.4H8.8H8.75V1V3.03108H7.35V1V0.95H7.3H6.7H6.65V1V3.03108H5.25V1V0.95H5.2H4.6ZM2.00195 4.22027H1.9691L1.95606 4.25043L0.954106 6.56784L0.95 6.57733V6.58768V12V12.05H1H13H13.05V12V6.57839V6.56649L13.0446 6.55586L12.0298 4.54504L12.0159 4.51757H11.9852H10H9.95V4.56757V5.16216V5.21216H10H11.5841L12.1336 6.30135H1.83137L2.4309 4.91486H4H4.05V4.86486V4.27027V4.22027H4H2.00195ZM1.65 6.99595H12.35V11.3554H1.65V6.99595Z'
      fill={color}
      stroke={color}
      strokeWidth='0.1'
    />
  </svg>
)

export const ElectricalEngineeringIcon: React.FC<SvgIconProps> = ({
  color,
}) => (
  <svg
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.81689 1.12649L7.67789 0L5.29935 2.37854L4.88011 1.95765L4.09649 1.18348L2.96846 2.31151L3.44315 2.7862L1.66638 4.59211L1.66562 4.59287C1.07672 5.18658 1.07549 6.15875 1.66742 6.75068L2.38839 7.47165L0.285156 9.57773L1.41144 10.7165L3.52335 8.60462L4.24454 9.3278C4.8365 9.91977 5.80875 9.91849 6.40245 9.32949L6.40311 9.32884L8.20544 7.55319L8.67908 8.02967L9.8173 6.89771L8.61607 5.69647L11.0015 3.31107L9.86247 2.18458L7.48332 4.56373L6.43149 3.51189L8.81689 1.12649ZM5.29888 2.99691L5.29889 2.99692L7.67961 0.616206L7.67959 0.61619L5.29888 2.99691ZM7.48345 5.18148L7.48347 5.1815L9.86419 2.80078L9.86417 2.80077L7.48345 5.18148ZM8.68099 7.41157L8.20882 6.93656L8.20868 6.93669L8.68086 7.41171L8.68099 7.41157ZM6.00471 9.09923C5.57746 9.43775 4.94582 9.41092 4.55363 9.01873L3.52392 7.98618L3.52376 7.98635L4.55348 9.01885C4.94571 9.41108 5.57746 9.43787 6.00471 9.09923ZM1.41328 10.0968L1.41315 10.0969L0.90114 9.57922L3.00607 7.47144L1.97636 6.44173C1.55538 6.02075 1.55538 5.32384 1.97636 4.90001L4.05854 2.7837L3.58635 2.31151L4.09836 1.7995L4.09838 1.79952L3.5865 2.3114L4.05869 2.78358L1.97651 4.89989C1.55552 5.32372 1.55552 6.02063 1.97651 6.44161L3.00622 7.47132L0.901289 9.5791L1.41328 10.0968ZM7.69681 6.42455L4.5707 3.30128L2.49421 5.4119C2.3463 5.55982 2.3463 5.78169 2.49421 5.92676L5.06564 8.50388C5.21356 8.64895 5.43827 8.64895 5.58334 8.50388V8.50103L7.69681 6.42455Z'
      fill={color}
    />
  </svg>
)

export const PlumbingEngineeringIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.507121 5.00037e-05C0.440865 -0.00088702 0.375084 0.0113536 0.3136 0.0360605C0.252116 0.0607674 0.196155 0.0974477 0.14897 0.14397C0.101785 0.190492 0.0643173 0.245928 0.0387434 0.307057C0.0131696 0.368186 0 0.433787 0 0.50005C0 0.566313 0.0131696 0.631914 0.0387434 0.693043C0.0643173 0.754172 0.101785 0.809608 0.14897 0.85613C0.196155 0.902652 0.252116 0.939333 0.3136 0.96404C0.375084 0.988746 0.440865 1.00099 0.507121 1.00005H1.00712V2.50005C1.00712 4.42722 2.57995 6.00005 4.50712 6.00005H6.42704C6.48072 6.00887 6.53548 6.00887 6.58915 6.00005H7.00712H8.50712C8.78859 6.00005 9.00712 6.21858 9.00712 6.50005V8.00005H8.50712C8.44087 7.99911 8.37508 8.01135 8.3136 8.03606C8.25212 8.06077 8.19615 8.09745 8.14897 8.14397C8.10178 8.19049 8.06432 8.24593 8.03874 8.30706C8.01317 8.36819 8 8.43379 8 8.50005C8 8.56631 8.01317 8.63191 8.03874 8.69304C8.06432 8.75417 8.10178 8.80961 8.14897 8.85613C8.19615 8.90265 8.25212 8.93933 8.3136 8.96404C8.37508 8.98875 8.44087 9.00099 8.50712 9.00005H12.5071C12.5734 9.00099 12.6392 8.98875 12.7006 8.96404C12.7621 8.93933 12.8181 8.90265 12.8653 8.85613C12.9125 8.80961 12.9499 8.75417 12.9755 8.69304C13.0011 8.63191 13.0142 8.56631 13.0142 8.50005C13.0142 8.43379 13.0011 8.36819 12.9755 8.30706C12.9499 8.24593 12.9125 8.19049 12.8653 8.14397C12.8181 8.09745 12.7621 8.06077 12.7006 8.03606C12.6392 8.01135 12.5734 7.99911 12.5071 8.00005H12.0071V6.50005C12.0071 4.57288 10.4343 3.00005 8.50712 3.00005H7.00712H6.59892C6.56606 2.99413 6.53269 2.99151 6.49931 2.99224C6.47441 2.99299 6.4496 2.9956 6.42509 3.00005H4.50712C4.22416 3.00005 4.00712 2.78212 4.00712 2.50005V1.00005H4.50712C4.57338 1.00099 4.63916 0.988746 4.70064 0.96404C4.76213 0.939333 4.81809 0.902652 4.86527 0.85613C4.91246 0.809608 4.94992 0.754172 4.9755 0.693043C5.00107 0.631914 5.01424 0.566313 5.01424 0.50005C5.01424 0.433787 5.00107 0.368186 4.9755 0.307057C4.94992 0.245928 4.91246 0.190492 4.86527 0.14397C4.81809 0.0974477 4.76213 0.0607674 4.70064 0.0360605C4.63916 0.0113536 4.57338 -0.00088702 4.50712 5.00037e-05H0.507121ZM2.00712 1.00005H3.00712V2.50005C3.00712 3.32198 3.68408 4.00005 4.50712 4.00005H6.00712V5.00005H4.50712C3.12029 5.00005 2.00712 3.88688 2.00712 2.50005V1.00005ZM7.00712 4.00005H8.50712C9.89395 4.00005 11.0071 5.11322 11.0071 6.50005V8.00005H10.0071V6.50005C10.0071 5.67752 9.32965 5.00005 8.50712 5.00005H7.00712V4.00005ZM10.5384 9.60161L10.1224 10.2208C10.1224 10.2208 9.86358 10.6077 9.60282 11.0665C9.47245 11.2959 9.34076 11.544 9.23564 11.7852C9.13051 12.0264 9.03837 12.2379 9.03837 12.5274C9.03837 13.3428 9.72292 14 10.5384 14C11.3538 14 12.0384 13.3428 12.0384 12.5274C12.0384 12.2379 11.9462 12.0264 11.8411 11.7852C11.736 11.544 11.6043 11.2959 11.4739 11.0665C11.2132 10.6077 10.9544 10.2208 10.9544 10.2208L10.5384 9.60161ZM10.5384 11.4551C10.5701 11.5089 10.5706 11.5039 10.6028 11.5606C10.7224 11.7711 10.8408 11.9946 10.9231 12.1836C11.0055 12.3727 11.0384 12.5494 11.0384 12.5274C11.0384 12.782 10.8229 13 10.5384 13C10.2538 13 10.0384 12.782 10.0384 12.5274C10.0384 12.5494 10.0712 12.3727 10.1536 12.1836C10.236 11.9946 10.3543 11.7711 10.4739 11.5606C10.5062 11.5039 10.5067 11.5089 10.5384 11.4551Z'
      fill={color}
    />
  </svg>
)

export const PlusSignIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.59238 1.29639V9.00009M8.59238 9.00009V16.7038M8.59238 9.00009H0.888672M8.59238 9.00009H16.2961'
      stroke={color}
      strokeWidth='1.77778'
      strokeLinecap='square'
      strokeLinejoin='round'
    />
  </svg>
)
//#endregion

//#region Menu Icons
export const OrganizationLogo = () => (
  <svg
    width='44'
    height='44'
    viewBox='0 0 44 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <rect x='0.5' y='0.5' width='43' height='43' rx='21.5' fill='#E7E7E7' />
    <rect
      x='0.5'
      y='0.5'
      width='43'
      height='43'
      rx='21.5'
      fill='url(#pattern0_2817_1038)'
    />
    <rect x='0.5' y='0.5' width='43' height='43' rx='21.5' stroke='#BABABA' />
    <defs>
      <pattern
        id='pattern0_2817_1038'
        patternContentUnits='objectBoundingBox'
        width='1'
        height='1'
      >
        <use xlinkHref='#image0_2817_1038' transform='scale(0.00444444)' />
      </pattern>
      <image
        id='image0_2817_1038'
        width='225'
        height='225'
        preserveAspectRatio='none'
        xlinkHref='data:image/png;base64,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'
      />
    </defs>
  </svg>
)

export const DashboardIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 19C14.9706 19 19 14.9706 19 10C19 7.51762 17.995 5.26991 16.3696 3.6417C14.7405 2.0097 12.4881 1 10 1C7.51186 1 5.25952 2.0097 3.63038 3.6417C2.00503 5.26991 1 7.51757 1 10C1 14.9706 5.02943 19 10 19Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1 10H2.8'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.62891 3.6416L5.03718 5.0499'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 1V2.8'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.9992 10H17.1992'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.3673 3.6416L14.959 5.0499'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 8.19995V13.6'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.1323 15.4883C15.4867 17.6241 12.9034 19.0001 9.99875 19.0001C7.09409 19.0001 4.51082 17.6241 2.86523 15.4883C4.96815 14.2868 7.40328 13.6001 9.99875 13.6001C12.5942 13.6001 15.0293 14.2868 17.1323 15.4883Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ProjectsIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.4 1H2.6C2.03995 1 1.75992 1 1.54601 1.10899C1.35785 1.20487 1.20487 1.35785 1.10899 1.54601C1 1.75992 1 2.03995 1 2.6V6.4C1 6.96005 1 7.24008 1.10899 7.45399C1.20487 7.64215 1.35785 7.79513 1.54601 7.89101C1.75992 8 2.03995 8 2.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V2.6C8 2.03995 8 1.75992 7.89101 1.54601C7.79513 1.35785 7.64215 1.20487 7.45399 1.10899C7.24008 1 6.96005 1 6.4 1Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4 1H13.6C13.0399 1 12.7599 1 12.546 1.10899C12.3578 1.20487 12.2049 1.35785 12.109 1.54601C12 1.75992 12 2.03995 12 2.6V6.4C12 6.96005 12 7.24008 12.109 7.45399C12.2049 7.64215 12.3578 7.79513 12.546 7.89101C12.7599 8 13.0399 8 13.6 8H17.4C17.9601 8 18.2401 8 18.454 7.89101C18.6422 7.79513 18.7951 7.64215 18.891 7.45399C19 7.24008 19 6.96005 19 6.4V2.6C19 2.03995 19 1.75992 18.891 1.54601C18.7951 1.35785 18.6422 1.20487 18.454 1.10899C18.2401 1 17.9601 1 17.4 1Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4 12H13.6C13.0399 12 12.7599 12 12.546 12.109C12.3578 12.2049 12.2049 12.3578 12.109 12.546C12 12.7599 12 13.0399 12 13.6V17.4C12 17.9601 12 18.2401 12.109 18.454C12.2049 18.6422 12.3578 18.7951 12.546 18.891C12.7599 19 13.0399 19 13.6 19H17.4C17.9601 19 18.2401 19 18.454 18.891C18.6422 18.7951 18.7951 18.6422 18.891 18.454C19 18.2401 19 17.9601 19 17.4V13.6C19 13.0399 19 12.7599 18.891 12.546C18.7951 12.3578 18.6422 12.2049 18.454 12.109C18.2401 12 17.9601 12 17.4 12Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.4 12H2.6C2.03995 12 1.75992 12 1.54601 12.109C1.35785 12.2049 1.20487 12.3578 1.10899 12.546C1 12.7599 1 13.0399 1 13.6V17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7951 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H6.4C6.96005 19 7.24008 19 7.45399 18.891C7.64215 18.7951 7.79513 18.6422 7.89101 18.454C8 18.2401 8 17.9601 8 17.4V13.6C8 13.0399 8 12.7599 7.89101 12.546C7.79513 12.3578 7.64215 12.2049 7.45399 12.109C7.24008 12 6.96005 12 6.4 12Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const TeamIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='22'
    height='20'
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.52743 8.12216C10.4389 8.12216 11.9884 6.57258 11.9884 4.66106C11.9884 2.74954 10.4389 1.19995 8.52743 1.19995C6.61595 1.19995 5.06641 2.74954 5.06641 4.66106C5.06641 6.57258 6.61595 8.12216 8.52743 8.12216Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.2559 1.69434C16.2609 2.29998 16.9332 3.402 16.9332 4.661C16.9332 5.92 16.2609 7.02202 15.2559 7.62766'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.11133 18.4065V18.9998H15.9443V18.4065C15.9443 16.1912 15.9443 15.0836 15.5132 14.2374C15.134 13.4931 14.5288 12.888 13.7845 12.5087C12.9384 12.0776 11.8308 12.0776 9.61555 12.0776H7.44005C5.2248 12.0776 4.11718 12.0776 3.27104 12.5087C2.52678 12.888 1.92167 13.4931 1.54245 14.2374C1.11133 15.0836 1.11133 16.1912 1.11133 18.4065Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.8902 18.9997V18.4063C20.8902 16.191 20.8902 15.0834 20.4591 14.2372C20.0799 13.4929 19.4747 12.8878 18.7305 12.5085'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ReportsIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.5 1H2.5C1.67157 1 1 1.67157 1 2.5V17.5C1 18.3284 1.67157 19 2.5 19H17.5C18.3284 19 19 18.3284 19 17.5V2.5C19 1.67157 18.3284 1 17.5 1Z'
      stroke={color}
      strokeLinejoin='round'
    />
    <path d='M8.5 4.5H4.5V8.5H8.5V4.5Z' stroke={color} strokeLinejoin='round' />
    <path
      d='M8.5 11.5H4.5V15.5H8.5V11.5Z'
      stroke={color}
      strokeLinejoin='round'
    />
    <path
      d='M11.5 12H15.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.5 15.5H15.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.5 4.5H15.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.5 8H15.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const HomeIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 8.29821C0 7.72385 0 7.43667 0.0740273 7.17221C0.139601 6.93794 0.247366 6.7176 0.392027 6.52201C0.555337 6.30121 0.782021 6.1249 1.23539 5.77228L8.0177 0.497153C8.36902 0.2239 8.54468 0.0872738 8.73865 0.034755C8.9098 -0.011585 9.0902 -0.011585 9.26135 0.034755C9.45532 0.0872738 9.63098 0.2239 9.98231 0.497153L16.7646 5.77228C17.218 6.1249 17.4447 6.30121 17.608 6.52201C17.7526 6.7176 17.8604 6.93794 17.926 7.17221C18 7.43667 18 7.72385 18 8.29821V15.5331C18 16.6532 18 17.2133 17.782 17.6411C17.5903 18.0174 17.2843 18.3234 16.908 18.5152C16.4802 18.7331 15.9201 18.7331 14.8 18.7331H3.2C2.0799 18.7331 1.51984 18.7331 1.09202 18.5152C0.715695 18.3234 0.409734 18.0174 0.217987 17.6411C0 17.2133 0 16.6532 0 15.5331V8.29821Z'
      fill={color}
    />
  </svg>
)

export const FavoritesIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='18'
    viewBox='0 0 20 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.99384 2.92223C8.19442 0.81856 5.19377 0.252678 2.93923 2.17901C0.68468 4.10535 0.367271 7.32608 2.13778 9.60436C3.47508 11.3252 7.27416 14.7799 9.05321 16.3674C9.38025 16.6592 9.54377 16.8051 9.73525 16.8626C9.90148 16.9125 10.0862 16.9125 10.2524 16.8626C10.4439 16.8051 10.6074 16.6592 10.9345 16.3674C12.7135 14.7799 16.5126 11.3252 17.8499 9.60436C19.6204 7.32608 19.3417 4.08508 17.0484 2.17901C14.7551 0.272941 11.7933 0.81856 9.99384 2.92223Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DraftsIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='24'
    height='20'
    viewBox='0 0 24 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.29641 7.75L5.84 7.75C6.45606 7.75 6.76409 7.75 6.99939 7.62738C7.20637 7.51953 7.37465 7.34742 7.48011 7.13574C7.6 6.89509 7.6 6.58006 7.6 5.95L7.6 1.30314M9.78705 1L17.72 1C19.5682 1 20.4923 1 21.1982 1.36785C21.8191 1.69143 22.3239 2.20774 22.6403 2.84278C23 3.56473 23 4.50982 23 6.4L23 13.6C23 15.4902 23 16.4353 22.6403 17.1572C22.3239 17.7923 21.8191 18.3086 21.1982 18.6321C20.4923 19 19.5682 19 17.72 19L6.28 19C4.43183 19 3.50774 19 2.80183 18.6321C2.1809 18.3086 1.67606 17.7923 1.35968 17.1572C1 16.4353 1 15.4902 1 13.6L1 9.98675C1 9.16126 1 8.74851 1.09118 8.36009C1.17202 8.01572 1.30535 7.68651 1.48629 7.38454C1.69036 7.04395 1.97574 6.75209 2.54648 6.16838L6.05352 2.58163C6.62426 1.99791 6.90963 1.70606 7.24266 1.49734C7.53792 1.31229 7.85981 1.17593 8.19653 1.09325C8.57632 1 8.9799 1 9.78705 1Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ArchiveIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='18'
    viewBox='0 0 20 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.65 5.44444V12.7333C17.65 14.2268 17.65 14.9735 17.3557 15.544C17.0969 16.0457 16.6838 16.4537 16.1758 16.7094C15.5982 17 14.8421 17 13.33 17H6.67C5.15786 17 4.40179 17 3.82423 16.7094C3.31619 16.4537 2.90314 16.0457 2.64428 15.544C2.35 14.9735 2.35 14.2268 2.35 12.7333V5.44444M2.44 1H17.56C18.064 1 18.3161 1 18.5086 1.09688C18.6779 1.1821 18.8156 1.31809 18.9019 1.48534C19 1.67549 19 1.9244 19 2.42222V4.02222C19 4.52005 19 4.76896 18.9019 4.9591C18.8156 5.12636 18.6779 5.26234 18.5086 5.34756C18.3161 5.44444 18.064 5.44444 17.56 5.44444H2.44C1.93595 5.44444 1.68393 5.44444 1.49141 5.34756C1.32206 5.26234 1.18438 5.12636 1.09809 4.9591C1 4.76896 1 4.52005 1 4.02222V2.42222C1 1.9244 1 1.67549 1.09809 1.48534C1.18438 1.31809 1.32206 1.1821 1.49141 1.09688C1.68393 1 1.93595 1 2.44 1ZM7.84 8.55556H12.16C12.664 8.55556 12.9161 8.55556 13.1086 8.65244C13.2779 8.73766 13.4156 8.87364 13.5019 9.0409C13.6 9.23104 13.6 9.47995 13.6 9.97778V10.6889C13.6 11.1867 13.6 11.4356 13.5019 11.6258C13.4156 11.793 13.2779 11.929 13.1086 12.0142C12.9161 12.1111 12.664 12.1111 12.16 12.1111H7.84C7.33595 12.1111 7.08393 12.1111 6.89141 12.0142C6.72206 11.929 6.58438 11.793 6.49809 11.6258C6.4 11.4356 6.4 11.1867 6.4 10.6889V9.97778C6.4 9.47995 6.4 9.23104 6.49809 9.0409C6.58438 8.87364 6.72206 8.73766 6.89141 8.65244C7.08393 8.55556 7.33595 8.55556 7.84 8.55556Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ToolIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.20005 5.00005H5.00005M5.00005 5.00005H0.800049M5.00005 5.00005V9.20005M5.00005 5.00005L5.00005 0.800049'
      stroke={color}
      strokeLinecap='round'
    />
  </svg>
)

export const SettingsIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='20'
    height='16'
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 4L13 4M13 4C13 5.65686 14.3431 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4ZM7 12L19 12M7 12C7 13.6569 5.65685 15 4 15C2.34315 15 1 13.6569 1 12C1 10.3431 2.34315 9 4 9C5.65685 9 7 10.3431 7 12Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
//#endregion

//#region Start new
export const StartNewFileIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='59'
    height='77'
    viewBox='0 0 59 77'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23 12H12M12 12H1M12 12V23M12 12L12 1'
      stroke={color}
      strokeLinecap='round'
    />
    <path
      d='M31.5499 58.51L4 43.2045L5.53055 34.0212L42.2638 14.124L57.5693 34.0212V43.2045L31.5499 58.51Z'
      fill='#E5F0FF'
    />
    <path
      d='M31.5488 76.4684L4.8291 61.7741V51.7988L31.5488 66.495V76.4684Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M58.2714 61.7741L31.5498 76.4684V66.495L58.2714 51.7988V61.7741Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5488 76.4706L4.8291 61.7762V51.801L31.5488 66.4972V76.4706Z'
      fill='#E5F0FF'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M58.2714 61.7762L31.5498 76.4706V66.4972L58.2714 51.801V61.7762Z'
      fill='#E5F0FF'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5488 37.1062L58.2704 51.8023L31.5488 66.4985L4.8291 51.8023L31.5488 37.1062Z'
      fill='#E5F0FF'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M58.2714 51.8023L31.5498 37.1062'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5488 37.1062L4.8291 51.8023'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M58.2714 43.6444L31.5498 28.9482'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5488 28.9482L4.8291 43.6444'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5488 58.3919L4.8291 43.6976V33.7223L18.1899 26.3743L31.5488 48.4166V58.3919Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M58.2714 43.6981L31.5498 58.3924V48.4172L58.2714 33.7229V43.6981Z'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M31.5498 28.9511V18.9758'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M4.8291 33.7234L42.4258 13L58.2704 33.6725V43.6478'
      stroke={color}
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

export const AddNewClientIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='47'
    height='33'
    viewBox='0 0 47 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 12.5H6.5M6.5 12.5H1M6.5 12.5V18M6.5 12.5L6.5 7'
      stroke={color}
      strokeLinecap='round'
    />
    <path
      d='M24.8316 12.977C28.1389 12.977 30.8199 10.2958 30.8199 6.98848C30.8199 3.68113 28.1389 1 24.8316 1C21.5243 1 18.8433 3.68113 18.8433 6.98848C18.8433 10.2958 21.5243 12.977 24.8316 12.977Z'
      fill='#E5F0FF'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M36.4731 1.85547C38.2122 2.90337 39.3753 4.8101 39.3753 6.98845C39.3753 9.1668 38.2122 11.0735 36.4731 12.1214'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 30.7712V31.7978H37.6643V30.7712C37.6643 26.9382 37.6643 25.0217 36.9184 23.5577C36.2622 22.2699 35.2152 21.2229 33.9275 20.5667C32.4635 19.8208 30.5471 19.8208 26.7142 19.8208H22.9501C19.1172 19.8208 17.2008 19.8208 15.7368 20.5667C14.449 21.2229 13.4021 22.2699 12.7459 23.5577C12 25.0217 12 26.9382 12 30.7712Z'
      fill='#E5F0FF'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M46.2214 31.7974V30.7709C46.2214 26.9379 46.2214 25.0214 45.4755 23.5574C44.8194 22.2696 43.7724 21.2226 42.4846 20.5664'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const AddNewProjectIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='55'
    height='48'
    viewBox='0 0 55 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M54 10H45M45 10H36M45 10V19M45 10L45 1'
      stroke={color}
      strokeLinecap='round'
    />
    <path
      d='M1 12.044C1 10.9151 1.91899 10 3.05263 10H15.3684L20.5 16.1321H37.9474C39.081 16.1321 40 17.0472 40 18.1761V44.7484C40 45.8773 39.081 46.7925 37.9474 46.7925H3.05263C1.91899 46.7925 1 45.8773 1 44.7484V12.044Z'
      fill='#E5F0FF'
      stroke={color}
      strokeLinejoin='round'
    />
    <path d='M40 26.1887H1H40Z' fill='#E5F0FF' />
    <path d='M40 26.1887H1' stroke={color} strokeLinejoin='round' />
    <path d='M1 20.302V32.8114V20.302Z' fill='#E5F0FF' />
    <path
      d='M1 20.302V32.8114'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M40 20.302V32.8114V20.302Z' fill='#E5F0FF' />
    <path
      d='M40 20.302V32.8114'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
//#endregion

export const InviteUserIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    width='22'
    height='20'
    viewBox='0 0 22 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.5 8C10.433 8 12 6.433 12 4.5C12 2.56701 10.433 1 8.5 1C6.567 1 5 2.56701 5 4.5C5 6.433 6.567 8 8.5 8Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.304 1.5C16.3204 2.11245 17.0002 3.22685 17.0002 4.5C17.0002 5.77315 16.3204 6.88755 15.304 7.5'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1 18.4V19H16V18.4C16 16.1598 16 15.0397 15.5641 14.184C15.1806 13.4314 14.5686 12.8195 13.816 12.436C12.9603 12 11.8402 12 9.6 12H7.4C5.1598 12 4.0397 12 3.18404 12.436C2.43139 12.8195 1.81947 13.4314 1.43598 14.184C1 15.0397 1 16.1598 1 18.4Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21 18.9996V18.3996C21 16.1594 21 15.0393 20.564 14.1836C20.1805 13.431 19.5686 12.819 18.8159 12.4355'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const AIAnimatedIcon = () => (
  <svg
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.94482 18.2056C9.25489 18.2056 9.47637 17.9978 9.52067 17.6565C9.99316 13.6498 10.1851 13.5311 14.2456 12.893C14.6147 12.8336 14.8362 12.6407 14.8362 12.3142C14.8362 12.0026 14.6147 11.7948 14.3194 11.7355C10.1999 10.9341 9.99316 10.9638 9.52067 6.97192C9.47637 6.63061 9.25489 6.42285 8.94482 6.42285C8.63475 6.42285 8.41327 6.63061 8.36898 6.95708C7.86696 11.0232 7.7193 11.1716 3.58502 11.7355C3.28971 11.7651 3.05347 12.0026 3.05347 12.3142C3.05347 12.6258 3.27495 12.8336 3.57025 12.893C7.73407 13.6943 7.85219 13.6943 8.36898 17.6862C8.41327 17.9978 8.63475 18.2056 8.94482 18.2056Z'
      fill='#316CD6'
    />
    <path
      d='M8.94482 18.2056C9.25489 18.2056 9.47637 17.9978 9.52067 17.6565C9.99316 13.6498 10.1851 13.5311 14.2456 12.893C14.6147 12.8336 14.8362 12.6407 14.8362 12.3142C14.8362 12.0026 14.6147 11.7948 14.3194 11.7355C10.1999 10.9341 9.99316 10.9638 9.52067 6.97192C9.47637 6.63061 9.25489 6.42285 8.94482 6.42285C8.63475 6.42285 8.41327 6.63061 8.36898 6.95708C7.86696 11.0232 7.7193 11.1716 3.58502 11.7355C3.28971 11.7651 3.05347 12.0026 3.05347 12.3142C3.05347 12.6258 3.27495 12.8336 3.57025 12.893C7.73407 13.6943 7.85219 13.6943 8.36898 17.6862C8.41327 17.9978 8.63475 18.2056 8.94482 18.2056Z'
      fill='url(#paint0_linear_2482_2431)'
    />
    <path
      d='M4.23452 7.59892C4.42056 7.59892 4.55345 7.47427 4.58003 7.26948C4.86352 4.86545 4.97869 4.79422 7.41497 4.41136C7.63645 4.37574 7.76933 4.25999 7.76933 4.06411C7.76933 3.87713 7.63645 3.75248 7.45926 3.71686C4.98755 3.23606 4.86352 3.25386 4.58003 0.858738C4.55345 0.65395 4.42056 0.529297 4.23452 0.529297C4.04848 0.529297 3.91559 0.65395 3.88901 0.849834C3.5878 3.28948 3.49921 3.37852 1.01864 3.71686C0.841454 3.73467 0.699707 3.87713 0.699707 4.06411C0.699707 4.25109 0.832595 4.37574 1.00978 4.41136C3.50807 4.89216 3.57894 4.89216 3.88901 7.28729C3.91559 7.47427 4.04848 7.59892 4.23452 7.59892Z'
      fill='#316CD6'
    />
    <path
      d='M4.23452 7.59892C4.42056 7.59892 4.55345 7.47427 4.58003 7.26948C4.86352 4.86545 4.97869 4.79422 7.41497 4.41136C7.63645 4.37574 7.76933 4.25999 7.76933 4.06411C7.76933 3.87713 7.63645 3.75248 7.45926 3.71686C4.98755 3.23606 4.86352 3.25386 4.58003 0.858738C4.55345 0.65395 4.42056 0.529297 4.23452 0.529297C4.04848 0.529297 3.91559 0.65395 3.88901 0.849834C3.5878 3.28948 3.49921 3.37852 1.01864 3.71686C0.841454 3.73467 0.699707 3.87713 0.699707 4.06411C0.699707 4.25109 0.832595 4.37574 1.00978 4.41136C3.50807 4.89216 3.57894 4.89216 3.88901 7.28729C3.91559 7.47427 4.04848 7.59892 4.23452 7.59892Z'
      fill='url(#paint1_linear_2482_2431)'
    />
    <path
      d='M14.838 9.95918C14.962 9.95918 15.0506 9.87608 15.0683 9.73955C15.2573 8.13686 15.3341 8.08938 16.9583 7.83414C17.1059 7.81039 17.1945 7.73323 17.1945 7.60264C17.1945 7.47798 17.1059 7.39488 16.9878 7.37114C15.34 7.0506 15.2573 7.06247 15.0683 5.46572C15.0506 5.3292 14.962 5.24609 14.838 5.24609C14.714 5.24609 14.6254 5.3292 14.6076 5.45979C14.4068 7.08621 14.3478 7.14557 12.6941 7.37114C12.5759 7.38301 12.4814 7.47798 12.4814 7.60264C12.4814 7.72729 12.57 7.81039 12.6882 7.83414C14.3537 8.15467 14.4009 8.15467 14.6076 9.75142C14.6254 9.87608 14.714 9.95918 14.838 9.95918Z'
      fill='#316CD6'
    />
    <path
      d='M14.838 9.95918C14.962 9.95918 15.0506 9.87608 15.0683 9.73955C15.2573 8.13686 15.3341 8.08938 16.9583 7.83414C17.1059 7.81039 17.1945 7.73323 17.1945 7.60264C17.1945 7.47798 17.1059 7.39488 16.9878 7.37114C15.34 7.0506 15.2573 7.06247 15.0683 5.46572C15.0506 5.3292 14.962 5.24609 14.838 5.24609C14.714 5.24609 14.6254 5.3292 14.6076 5.45979C14.4068 7.08621 14.3478 7.14557 12.6941 7.37114C12.5759 7.38301 12.4814 7.47798 12.4814 7.60264C12.4814 7.72729 12.57 7.81039 12.6882 7.83414C14.3537 8.15467 14.4009 8.15467 14.6076 9.75142C14.6254 9.87608 14.714 9.95918 14.838 9.95918Z'
      fill='url(#paint2_linear_2482_2431)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2482_2431'
        x1='12.3556'
        y1='9.07396'
        x2='6.03826'
        y2='20.2578'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#06004A'>
          <animate
            attributeName='stopColor'
            values='#06004A; #3D8BFF; #06004A'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.43' stopColor='#3D8BFF'>
          <animate
            attributeName='stopColor'
            values='#3D8BFF; #8CBAFF; #3D8BFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.755' stopColor='#8CBAFF'>
          <animate
            attributeName='stopColor'
            values='#8CBAFF; #06004A; #8CBAFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
      </linearGradient>
      <linearGradient
        id='paint1_linear_2482_2431'
        x1='6.28099'
        y1='2.11996'
        x2='2.49058'
        y2='8.83026'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#06004A'>
          <animate
            attributeName='stopColor'
            values='#06004A; #3D8BFF; #06004A'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.43' stopColor='#3D8BFF'>
          <animate
            attributeName='stopColor'
            values='#3D8BFF; #8CBAFF; #3D8BFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.755' stopColor='#8CBAFF'>
          <animate
            attributeName='stopColor'
            values='#8CBAFF; #06004A; #8CBAFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
      </linearGradient>
      <linearGradient
        id='paint2_linear_2482_2431'
        x1='16.2023'
        y1='6.30654'
        x2='13.6754'
        y2='10.7801'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#06004A'>
          <animate
            attributeName='stopColor'
            values='#06004A; #3D8BFF; #06004A'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.43' stopColor='#3D8BFF'>
          <animate
            attributeName='stopColor'
            values='#3D8BFF; #8CBAFF; #3D8BFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
        <stop offset='0.755' stopColor='#8CBAFF'>
          <animate
            attributeName='stopColor'
            values='#8CBAFF; #06004A; #8CBAFF'
            dur='3s'
            repeatCount='indefinite'
          ></animate>
        </stop>
      </linearGradient>
    </defs>
  </svg>
)

export const InfoIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8' fill='currentColor'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 7.5C4.92826 7.5 5.8185 7.13125 6.47487 6.47487C7.13125 5.8185 7.5 4.92826 7.5 4C7.5 3.07174 7.13125 2.1815 6.47487 1.52513C5.8185 0.868749 4.92826 0.5 4 0.5C3.07174 0.5 2.1815 0.868749 1.52513 1.52513C0.868749 2.1815 0.5 3.07174 0.5 4C0.5 4.92826 0.868749 5.8185 1.52513 6.47487C2.1815 7.13125 3.07174 7.5 4 7.5ZM4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8Z'
    />
    <path d='M4.46496 3.29395L3.31996 3.43745L3.27896 3.62745L3.50396 3.66895C3.65096 3.70395 3.67996 3.75695 3.64796 3.90345L3.27896 5.63745C3.18196 6.08595 3.33146 6.29695 3.68296 6.29695C3.95546 6.29695 4.27196 6.17095 4.41546 5.99795L4.45946 5.78995C4.35946 5.87795 4.21346 5.91295 4.11646 5.91295C3.97896 5.91295 3.92896 5.81645 3.96446 5.64645L4.46496 3.29395Z' />
    <path d='M3.99985 2.75C4.27599 2.75 4.49985 2.52614 4.49985 2.25C4.49985 1.97386 4.27599 1.75 3.99985 1.75C3.72371 1.75 3.49985 1.97386 3.49985 2.25C3.49985 2.52614 3.72371 2.75 3.99985 2.75Z' />
  </svg>,
  'Info',
)

export const ExportIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 11 10'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    fill='none'
  >
    <path d='M10 5L10 8.375C10 8.99632 9.49632 9.5 8.875 9.5L2.125 9.5C1.50368 9.5 1 8.99632 1 8.375L1 1.625C1 1.00368 1.50368 0.500002 2.125 0.500002L5.5 0.500001' />
    <path d='M7.75 0.5L10 0.5L10 2.75' />
    <path d='M5.5 5L10 0.5' />
  </svg>,
  'Export',
)

export const UpwardArrowIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 10 10'
    fill='currentColor'
  >
    <path d='M9.14865 0.663086C9.14865 0.346376 8.89191 0.089631 8.57519 0.0896312L3.4141 0.0896308C3.09739 0.0896311 2.84064 0.346376 2.84064 0.663086C2.84064 0.979797 3.09739 1.23654 3.4141 1.23654L8.00174 1.23654L8.00174 5.82418C8.00174 6.14089 8.25848 6.39764 8.5752 6.39764C8.89191 6.39764 9.14865 6.14089 9.14865 5.82418L9.14865 0.663086ZM0.980689 9.06858L8.98069 1.06858L8.1697 0.257592L0.169701 8.25759L0.980689 9.06858Z' />
  </svg>,
  'UpwardArrow',
)

export const DownwardArrowIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 10 10'
    fill='currentColor'
  >
    <path d='M9.14865 8.66309C9.14865 8.9798 8.89191 9.23654 8.57519 9.23654L3.4141 9.23654C3.09739 9.23654 2.84064 8.9798 2.84064 8.66309C2.84064 8.34638 3.09739 8.08963 3.4141 8.08963L8.00174 8.08963L8.00174 3.50199C8.00174 3.18528 8.25848 2.92853 8.5752 2.92853C8.89191 2.92853 9.14865 3.18528 9.14865 3.50199L9.14865 8.66309ZM0.980689 0.257592L8.98069 8.25759L8.1697 9.06858L0.169701 1.06858L0.980689 0.257592Z' />
  </svg>,
  'DownwardArrow',
)

export const LeftArrowIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 10' fill='none'>
    <path
      d='M0.561193 4.56119C0.318846 4.80354 0.318846 5.19646 0.561193 5.43881L4.51046 9.38807C4.75281 9.63042 5.14573 9.63042 5.38807 9.38807C5.63042 9.14573 5.63042 8.75281 5.38807 8.51046L1.87761 5L5.38807 1.48954C5.63042 1.24719 5.63042 0.854272 5.38807 0.611926C5.14573 0.369579 4.75281 0.369579 4.51046 0.611926L0.561193 4.56119ZM13 4.37943L1 4.37943V5.62057L13 5.62057V4.37943Z'
      fill='currentColor'
    />
  </svg>,
  'LeftArrow',
)

export const RightArrowIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 10' fill='none'>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M12.4388 4.5612C12.6811 4.80355 12.6811 5.19647 12.4388 5.43882L8.48952 9.38808C8.24717 9.63043 7.85425 9.63043 7.61191 9.38808C7.36956 9.14574 7.36956 8.75282 7.61191 8.51047L11.1224 5.00001L7.61191 1.48955C7.36956 1.2472 7.36956 0.854282 7.61191 0.611936C7.85425 0.369589 8.24717 0.369589 8.48952 0.611936L12.4388 4.5612ZM-2.28882e-05 4.37944H12V5.62058H-2.28882e-05V4.37944Z'
      fill='currentColor'
    />
  </svg>,
  'RightArrow',
)

export const ToolbarPanelIcon = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 10' fill='none'>
    <path
      d='M12.5 7.42857C12.5 8.59813 11.6077 9.5 10.5625 9.5H2.4375C1.39231 9.5 0.5 8.59813 0.5 7.42857L0.500001 2.57143C0.500001 1.40187 1.39231 0.5 2.4375 0.5L10.5625 0.500001C11.6077 0.500001 12.5 1.40187 12.5 2.57143V7.42857Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect x='7' y='2' width='4' height='6' rx='1' fill='currentColor' />
  </svg>,
  'ToolbarPanel',
)

export const ApproveIcon = createSvgIcon(
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.2 7L6.4 8.2L9.1 5.5M10.5407 2.7991C10.6643 3.09792 10.9014 3.33544 11.2 3.45944L12.2471 3.89319C12.546 4.01697 12.7834 4.2544 12.9072 4.55324C13.0309 4.85207 13.0309 5.18785 12.9072 5.48668L12.4737 6.53308C12.3499 6.83205 12.3497 7.16817 12.4741 7.46699L12.9068 8.51308C12.9682 8.66109 12.9998 8.81974 12.9998 8.97997C12.9998 9.1402 12.9683 9.29886 12.907 9.44689C12.8456 9.59492 12.7558 9.72942 12.6424 9.8427C12.5291 9.95598 12.3946 10.0458 12.2466 10.1071L11.2002 10.5405C10.9014 10.6641 10.6639 10.9012 10.5399 11.1999L10.1062 12.247C9.98239 12.5459 9.74497 12.7833 9.44614 12.9071C9.14732 13.0308 8.81156 13.0308 8.51273 12.9071L7.46637 12.4736C7.16753 12.3502 6.8319 12.3504 6.53324 12.4743L5.48614 12.9075C5.18747 13.0309 4.85201 13.0308 4.55342 12.9072C4.25484 12.7835 4.01755 12.5463 3.89369 12.2478L3.45983 11.2004C3.33628 10.9015 3.09913 10.664 2.80051 10.54L1.7534 10.1063C1.4547 9.98254 1.21735 9.74527 1.09353 9.4466C0.969705 9.14793 0.969537 8.81232 1.09306 8.51353L1.52648 7.46713C1.64995 7.16828 1.6497 6.83263 1.52578 6.53397L1.09298 5.48607C1.03162 5.33806 1.00003 5.17941 1 5.01918C0.999974 4.85895 1.03152 4.70029 1.09283 4.55226C1.15415 4.40423 1.24403 4.26973 1.35734 4.15645C1.47065 4.04317 1.60517 3.95333 1.75322 3.89206L2.79958 3.45863C3.09812 3.33518 3.33549 3.09832 3.45958 2.80003L3.89331 1.75289C4.01709 1.45405 4.25451 1.21662 4.55333 1.09284C4.85216 0.969054 5.18792 0.969054 5.48675 1.09284L6.53311 1.52627C6.83194 1.64975 7.16758 1.6495 7.46623 1.52557L8.51378 1.09351C8.81257 0.969796 9.14826 0.969821 9.44703 1.09358C9.7458 1.21734 9.98318 1.4547 10.107 1.75346L10.5408 2.80092L10.5407 2.7991Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'Approve',
)

export const ChevronIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='6'
    viewBox='0 0 10 6'
    fill='none'
  >
    <path
      d='M0.998047 0.571777L4.92578 4.49951L8.8535 0.571777'
      strokeMiterlimit='10'
      stroke='currentColor'
    />
  </svg>,
  'ArrowIcon',
)

interface AnimatedChevronIconProps {
  open: boolean
  reversed?: boolean
}

export const AnimatedChevronIcon = styled(
  ChevronIcon,
)<AnimatedChevronIconProps>(({ open, reversed = false }) => ({
  transition: 'transform 0.3s ease',
  transform:
    (open && !reversed) || (!open && reversed)
      ? 'rotate(180deg)'
      : 'rotate(0deg)',
}))

export const CheckedCheckboxIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <rect
      x='0.5'
      y='0.5'
      width='15'
      height='15'
      rx='1.5'
      stroke='currentColor'
    />
    <rect x='3' y='3' width='10' height='10' rx='0.5' fill='currentColor' />
  </svg>,
  'CheckedCheckboxIcon',
)

export const UncheckedCheckboxIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <rect
      x='0.5'
      y='0.5'
      width='15'
      height='15'
      rx='1.5'
      stroke='currentColor'
    />
  </svg>,
  'UncheckedCheckboxIcon',
)

export const MeasurementsEditIcon = createSvgIcon(
  <svg
    width='8'
    height='8'
    viewBox='0 0 8 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.82583 7H6.97979M0.671875 7H1.2587C1.43013 7 1.51585 7 1.59651 6.98063C1.66802 6.96346 1.73639 6.93514 1.7991 6.89671C1.86983 6.85337 1.93044 6.79276 2.05166 6.67154L6.45415 2.26906C6.74446 1.97874 6.74446 1.50805 6.45415 1.21774C6.16383 0.927421 5.69314 0.927422 5.40282 1.21774L1.00033 5.62022C0.87911 5.74144 0.818501 5.80205 0.775157 5.87278C0.736728 5.93549 0.70841 6.00386 0.69124 6.07537C0.671875 6.15604 0.671875 6.24175 0.671875 6.41318V7Z'
      stroke='currentColor'
      strokeWidth='0.7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'MeasurementsEditIcon',
)

export const MeasurementsConfirmIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='8'
    height='7'
    viewBox='0 0 8 7'
    fill='none'
  >
    <path
      d='M6.98149 1.24915L2.47981 5.75082L0.433594 3.70461'
      stroke='currentColor'
      strokeWidth='0.776151'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'MeasurementsConfirmIcon',
)
